<template>
  <div class="pt-3 pl-5 pr-5 page-fill">
    <div class="flex flex-col flex-1 min-h-0 overflow-hidden">
      <div
        class="row w-full justify-between flex"
        style="align-items: center"
      >
        <h1 class="title">Controls</h1>
        <div class="cardbody flex">
          <!-- <div class="flex flex-row-reverse mr-2 relative">
            <input type="file" accept=".xls,.xlsx" class="hidden" ref="file" @change="fileReader($event)" />
						<button class="btnprimary btns flex justify-center items-center" @click="showBlock = !showBlock">Add <img src="@/assets/Collapse.svg" alt="" class="ml-2" /></button>
						<ul class="card shadow-sm z-50 absolute cursor-pointer top-10" v-if="showBlock && showDropdown">
							<li @click="openFileModal" class="px-4 py-2 cursor-pointer border-b h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center">
								<div>Import</div>
							</li>
							<li @click="addControls" class="px-4 py-2 cursor-pointer border-b h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center">
								<div>Create</div>
							</li>
						</ul>
					</div> -->
          <div class="flex gap-3">
          <div ref="menuContainer" class="flex flex-row-reverse">
                <button @click="toggleMenu" class="btns flex justify-center items-center"  :class="isAddDisabled ? 'btndisabled pointer-events-none':'btnprimary'">Add</button>
                <ul  v-if="isMenuVisible" class="card shadow-sm z-50 absolute cursor-pointer top-24 w-40">
                  <li class="px-4 py-2 cursor-pointer border-b h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center" @click="customPopupPopup">
                    <div class="flex" ><img src="@/assets/newControl.svg" alt="" class="mr-2"/>New Control</div>
                  </li>
                  <li class="px-4 py-2 cursor-pointer h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center" @click="showpopupOnAddCloneControl">
                    <div class="flex" ><img src="@/assets/controlClone.svg" alt="" class="mr-2"/> Clone Control</div>
                  </li>
                </ul>
          </div>
          <div class="flex flex-row-reverse items-center gap-3">
            <button class="flex" @click="filterOpen" :class="tableRow.length == 0 ? 'filterButtondisabled pointer-events-none' : 'filterButton'">
              <img  v-if="tableRow.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
              <img v-else src="@/assets/filter.svg" class="filterIcon" />
              Filters
            </button>
          </div>
          </div>
        </div>
      </div>
      <div class="text-xs mt-3">
        Define, organize, and manage security controls across the organization. Map controls to systems, processes, and projects. Manage Key Performance Indicators (KPI) for the controls adopted or activated, ensuring consistent implementation, monitoring, and compliance with internal policies and external compliance frameworks. 
      </div>
      <div class="mt-5 table-section">
        <tableData
          class="flex-1 min-h-0"
          :tableRowData="tableRow"
          :headersData="headers"
          :loadData="dataLoading"
        ></tableData>
        <div v-if="toolTipActive">
          <tool-tip :tipText="toolTipText"></tool-tip>
        </div>
      </div>
      <popup v-if="showModal" :popUp="showModal">
        <template v-slot:header>
          <div class="flex items-center justify-between py-4 px-2 rounded">
            <!-- <h1 class="pl-2">{{ controlObject.controlNumber }}</h1> -->
            <h1 class="pl-2">Active Control</h1>
            <button class="float-right text-3xl" @click="onCancelbtn('close')">
              <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
            </button>
          </div>
        </template>
        <div>
        <fieldset>
          <div class="pl-4 pb-4 pr-4">
            <div class="w-full mt-3">
              <div class="controllabel">Control Title</div>
              <div class="text-sm mt-2" v-if="controlObject.controlTitle != undefined">{{ controlObject.controlTitle }}</div>
              <div class="text-sm mt-2" v-else>N/A</div>
            </div>
            <div class="flex mt-3">
              <div class="w-1/2">
                <div class="controllabel">CCID</div>
                <div class="text-sm mt-2" v-if="controlObject.clientUniqueId != undefined">{{ controlObject.clientUniqueId }}</div>
                <div class="text-sm mt-2" v-else>N/A</div>
              </div>
              <!-- <div class="w-1/2">
                <div class="controllabel">Tier</div>
                <div class="text-sm mt-2">{{ controlObject.tier }}</div>
              </div> -->
              <div class="w-1/2">
                <div class="controllabel">Control Frequency</div>
                <div class="text-sm mt-2" v-if="controlObject.controlFrequency != undefined">{{ getControlFrequency(controlObject.controlFrequency) }}</div>
                <div class="text-sm mt-2" v-else>N/A</div>
              </div>
            </div>
            
            <div class="flex mt-3">
              <!-- <div class="w-1/2">
                <div class="controllabel">Control Number</div>
                <div class="text-sm mt-2" v-if="controlObject.controlNumber != undefined">{{ controlObject.controlNumber }}</div>
                <div class="text-sm mt-2" v-else>N/A</div>
              </div> -->
              <div class="w-1/2">
                <div class="controllabel">Control Class</div>
                <div class="text-sm mt-2" v-if="controlObject.controlClass != undefined && controlObject.controlClass != ''">{{ controlObject.controlClass }}</div>
                <div class="text-sm mt-2" v-else>N/A</div>
              </div>
              <div class="w-1/2">
                <div class="controllabel">Owner</div>
                <div class="text-sm mt-2">{{ getControlOwnerName(controlObject.controlOwner) }}</div>
              </div>
            </div>
            <div class="flex mt-3">
              <div class="w-1/2">
                <div class="controllabel">Priority</div>
                <div v-if="controlObject.controlPriority && typeof controlObject.controlPriority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2" :class="colorLabelBg(controlObject.controlPriority)">
									<div class="text-xs" :class="colorLabelText(controlObject.controlPriority)">
										{{ getProirityLabel(controlObject.controlPriority) }}
									</div>
								</div>
                <div v-else class="text-sm">N/A</div>
              </div>
            </div>
            
            <div class="flex mt-3">
              <div class="w-1/2">
                <div class="controllabel">Control Family</div>
                <div class="text-sm mt-2" v-if="controlObject.controlFamily != undefined && controlObject.controlFamily != ''">{{ controlObject.controlFamily }}</div>
                <div class="text-sm mt-2" v-else>N/A</div>
              </div>
              <div class="w-1/2">
                <div class="controllabel">Control Type</div>
                <div class="text-sm mt-2" v-if="controlObject.controlType != undefined && controlObject.controlType != ''">{{ controlObject.controlType }}</div>
                <div class="text-sm mt-2" v-else>N/A</div>
              </div>
            </div>

            <div class="w-full mt-3">
              <div class="controllabel">Control Guidance</div>
              <div class="text-sm mt-2" v-if="Object.keys(controlObject).includes('controlGuidance') && (controlObject.controlGuidance != undefined && controlObject.controlGuidance != '')">{{ controlObject.controlGuidance }}</div>
              <div class="text-sm mt-2" v-else>N/A</div>
            </div>
            <div class="w-full  mt-3">
              <div class="controllabel">Audit Methodology</div>
              <div class="text-sm mt-2" v-if="Object.keys(controlObject).includes('controlAuditMethodology') && (controlObject.controlAuditMethodology != undefined && controlObject.controlAuditMethodology != '')">{{ controlObject.controlAuditMethodology }}</div>
              <div class="text-sm mt-2" v-else>N/A</div>
            </div>
            <div class="w-full  mt-3">
              <div class="controllabel">Audit Success Criteria</div>
              <div class="text-sm mt-2" v-if="Object.keys(controlObject).includes('controlAuditSuccessCriteria') && (controlObject.controlAuditSuccessCriteria != undefined && controlObject.controlAuditSuccessCriteria != '')">{{ controlObject.controlAuditSuccessCriteria }}</div>
              <div class="text-sm mt-2" v-else>N/A</div>
            </div>
            <div class="w-full  mt-3">
              <div class="controllabel">Policies</div>
              <div class="text-sm mt-2" v-if="Object.keys(controlObject).includes('controlPolicies') && (controlObject.controlPolicies != undefined && controlObject.controlPolicies != '')">{{ controlObject.controlPolicies }}</div>
              <div class="text-sm mt-2" v-else>N/A</div>
            </div>
            <div class="w-full  mt-3">
              <div class="controllabel">Maintenance Task</div>
              <div class="text-sm mt-2" v-if="Object.keys(controlObject).includes('controlMaintenanceTask') && (controlObject.controlMaintenanceTask != undefined && controlObject.controlMaintenanceTask != '')">{{ controlObject.controlMaintenanceTask }}</div>
              <div class="text-sm mt-2" v-else>N/A</div>
            </div>
            
            <div class="w-full  mt-3">
              <div class="controllabel">FrameWork</div>
              <div class="text-sm mt-2" v-if="Object.keys(controlObject).includes('controlOptionFrameWork') && (controlObject.controlOptionFrameWork != undefined && controlObject.controlOptionFrameWork != '')">{{ controlObject.controlOptionFrameWork }}</div>
              <div class="text-sm mt-2" v-else>N/A</div>
            </div>
            <div class="w-full  mt-3">
              <div class="controllabel">Controls</div>
              <div class="text-sm mt-2" v-if="Object.keys(controlObject).includes('frameworkControls') && (controlObject.frameworkControls != undefined && controlObject.frameworkControls != '')">{{ controlObject.frameworkControls }}</div>
              <div class="text-sm mt-2" v-else>N/A</div>
            </div>
            <!-- <div class="w-1/2 mt-3">
              <div class="controllabel">Link Kpi's</div>
              <div class="text-sm mt-2">{{ controlObject.KPIs }}</div>
            </div> -->
          </div>
        </fieldset>
          </div>
      </popup>
       <popup v-if="customPopup" :popUp="customPopup">
        <template v-slot:header>
            <div class="flex items-center justify-between py-4 pl-2 pr-4 rounded">
                <h1 v-if="customControlObject != undefined && customControlObject.classificationType == 3 " class="pl-2">{{customControlObject.controlTitle}}</h1>
                <div v-else class="pl-2">
                    <h1 v-if="addpopup==false" >{{customControlObject.controlTitle || 'N/A'}}</h1>
                    <h1 v-else>Control</h1>
                </div>
                <button class="float-right text-3xl" @click="onCancelbtnCustom('close')">
                    <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                </button>
            </div>
        </template>
      <div class="flex flex-col h-full">
          <div class="flex-1 overflow-auto">
                  <fieldset :disabled="customControlObject._id">
                  <div>
                      <div class="statuscontainer popupbodycontainer">
                          <div class="formcontainer flex flex-col">
                              <div v-if="addpopup==true" class="row flex flex-row w-full">
                                  <div class="w-full mt-3">
                                      <label class="controllabel">Title</label>
                                      <!-- <div class="mb-3 mt-2 text-sm">{{ customControlObject.controlTitle || 'N/A'}}</div> -->
                                      <textarea 
                                          type="text-area"
                                          class="inputboxstyling mt-2"
                                          placeholder="Title"
                                          @input="v$.customControlObject.controlTitle.$touch()" 
                                          v-model.trim="customControlObject.controlTitle"
                                          :class="{
                                              'is-invalid': v$.customControlObject.controlTitle.$error
                                          }"
                                      ></textarea>
                                      <div v-if="v$.customControlObject.controlTitle.$error" class="text-red-500">
                                          <div class="error-text" v-if="v$.customControlObject.controlTitle.required.$invalid">Required</div>
                                          <div v-else-if="v$.customControlObject.controlTitle && v$.customControlObject.controlTitle.restrictCharacters100.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                      </div>
                                  </div>
                              </div>
                              <div class="flex flex-row w-full mt-3"> 
                                  <div class="w-6/12 " :class="{'topspace': addpopup}">
                                      <label class="controllabel text-xs">Tier</label>
                                      <!-- <div class="text-sm mt-2 mb-3">{{ controlFrequencyArray.find((item:any) => item.id === customControlObject.controlFrequency)?.label ?? 'N/A' }}</div> -->
                                      <!-- <select v-else class="mt-2" :class="{ 'is-invalid': v$.customControlObject.controlFrequency.$error,'inputboxstylingForSelectAtPopup': customControlObject.controlFrequency === '','stylingForInputboxstylingForSelectAtPopup': customControlObject.controlFrequency !== '' }" v-model="customControlObject.controlFrequency">
                                          <option value="" selected disabled hidden>Select</option>
                                          <option class="optionColors" v-for="(value, index) in controlFrequencyArray" :key="index" :value="value.id">{{ value.label }}</option>
                                      </select> -->
                                      <Select 
                                          v-model="customControlObject.categoryType"
                                          :options="tierTypes"
                                          optionLabel="value"
                                          optionValue="id"
                                          placeholder="Please select one"
                                          class="w-full custom-multiselect userSelect mt-2"
                                           @change="getTierNamesList(customControlObject.categoryType)"
                                          :class="{
                                        'is-invalid': v$.customControlObject.categoryType.$error,
                                        'inputboxstylingForSelectAtPopup': customControlObject.categoryType === '',
                                    }"
                                      />
                                      <div v-if="v$.customControlObject.categoryType.$error" class="text-red-500">
                                          <div class="error-text" v-if="v$.customControlObject.categoryType.required.$invalid">Required</div>
                                      </div>
                              
                                  </div>
                                  <div class="w-6/12 leftspacing" :class="{'topspace': addpopup}">
                                      <label class="controllabel text-xs">Scope</label>
                                      <!-- <div v-if="addpopup==false && selectedTabIndex==1" class="mb-3 mt-2 text-sm"> -->
                                      <!-- <div v-if="customControlObject.controlPriority && typeof customControlObject.controlPriority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2" :class="colorLabelBg(customControlObject.controlPriority)">
                                          <div class="text-xs" :class="colorLabelText(customControlObject.controlPriority)">
                                              {{ getProirityLabel(customControlObject.controlPriority) }}
                                          </div>
                                      </div> -->
                                      <!-- <div v-else>N/A</div> -->
                                      <!-- {{ dbPriority.find(item => item.value === customControlObject.controlPriority)?.key || 'N/A' }} -->
                                      <!-- </div> -->
                                      <!-- <select v-else class="mt-2" v-model="customControlObject.controlPriority" :class="{'inputboxstylingForSelectAtPopup': customControlObject.controlPriority === '','stylingForInputboxstylingForSelectAtPopup': customControlObject.controlPriority !== ''}">
                                          <option value="" selected disabled hidden>Select</option>
                                          <option class="optionColors" v-for="(value, index) in dbPriority" :key="index" :value="value.value">{{ value.key }}</option>
                                      </select> -->
                                              <AutoComplete 
                                              v-model="customControlObject.tierTitle"
                                              :suggestions="categoryList"
                                              @complete="asyncFindForTierTitle($event, customControlObject.categoryType)"
                                              optionLabel="label"
                                              optionValue="value"
                                              :forceSelection="true"
                                              :disabled="customControlObject.categoryType==''"
                                              placeholder="Type to search"
                                              class="p-inputtext-sm systemsstyling  mt-2"
                                              :class="{ 'p-invalid': v$.customControlObject.tierTitle.$error }"
                                              />
                                      <div v-if="v$.customControlObject.tierTitle.$error" class="text-red-500">
                                          <div class="error-text" v-if="v$.customControlObject.tierTitle.required.$invalid">Required</div>
                                      </div>
                                  </div>
                                  
                              </div>
                              <div class="flex flex-row w-full mt-3"> 
                                  <div class="w-6/12 " :class="{'topspace': addpopup}">
                                      <label class="controllabel text-xs">Frequency</label>
                                      <!-- <div class="text-sm mt-2 mb-3">{{ controlFrequencyArray.find((item:any) => item.id === customControlObject.controlFrequency)?.label ?? 'N/A' }}</div> -->
                                      <!-- <select v-else class="mt-2" :class="{ 'is-invalid': v$.customControlObject.controlFrequency.$error,'inputboxstylingForSelectAtPopup': customControlObject.controlFrequency === '','stylingForInputboxstylingForSelectAtPopup': customControlObject.controlFrequency !== '' }" v-model="customControlObject.controlFrequency">
                                          <option value="" selected disabled hidden>Select</option>
                                          <option class="optionColors" v-for="(value, index) in controlFrequencyArray" :key="index" :value="value.id">{{ value.label }}</option>
                                      </select> -->
                                      <Select 
                                          v-model="customControlObject.controlFrequency"
                                          :options="dbFrequency"
                                          optionLabel="key"
                                          optionValue="value"
                                          placeholder="Please select one"
                                          class="w-full custom-multiselect userSelect mt-2"
                                          :class="{
                                        'is-invalid': v$.customControlObject.controlFrequency.$error,
                                        'inputboxstylingForSelectAtPopup': customControlObject.controlFrequency === '',
                                    }"
                                      />
                                      <div v-if="v$.customControlObject.controlFrequency.$error" class="text-red-500">
                                          <div class="error-text" v-if="v$.customControlObject.controlFrequency.required.$invalid">Required</div>
                                      </div>
                              
                                  </div>
                                  <div class="w-6/12 leftspacing" :class="{'topspace': addpopup}">
                                      <label class="controllabel text-xs">Priority</label>
                                      <!-- <div v-if="addpopup==false && selectedTabIndex==1" class="mb-3 mt-2 text-sm"> -->
                                      <!-- <div v-if="customControlObject.controlPriority && typeof customControlObject.controlPriority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2" :class="colorLabelBg(customControlObject.controlPriority)">
                                          <div class="text-xs" :class="colorLabelText(customControlObject.controlPriority)">
                                              {{ getProirityLabel(customControlObject.controlPriority) }}
                                          </div>
                                      </div> -->
                                      <!-- <div v-else>N/A</div> -->
                                      <!-- {{ dbPriority.find(item => item.value === customControlObject.controlPriority)?.key || 'N/A' }} -->
                                      <!-- </div> -->
                                      <!-- <select v-else class="mt-2" v-model="customControlObject.controlPriority" :class="{'inputboxstylingForSelectAtPopup': customControlObject.controlPriority === '','stylingForInputboxstylingForSelectAtPopup': customControlObject.controlPriority !== ''}">
                                          <option value="" selected disabled hidden>Select</option>
                                          <option class="optionColors" v-for="(value, index) in dbPriority" :key="index" :value="value.value">{{ value.key }}</option>
                                      </select> -->
                                          <Select
                                          v-model="customControlObject.controlPriority"
                                          :options="dbPriority"
                                          optionLabel="key"
                                          optionValue="value"
                                          placeholder="Please select one"
                                          class="w-full custom-multiselect userSelect mt-2"
                                          :class="{
                                                'is-invalid': v$.customControlObject.controlPriority.$error,
                                                'inputboxstylingForSelectAtPopup': customControlObject.controlPriority === '',
                                            }"
                                          
                                      />
                                      <div v-if="v$.customControlObject.controlPriority.$error" class="text-red-500">
                                          <div class="error-text" v-if="v$.customControlObject.controlPriority.required.$invalid">Required</div>
                                      </div>
                                  </div>
                                  
                              </div>
                              <div class="flex flex-row w-full mt-3">
                              <div class="w-6/12 " :class="{'topspace': addpopup}">
                                      <label class="controllabel">Number</label>
                                      
                                      <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlNumber || 'N/A'}}</div>
                                      <input
                                          type="text"
                                          class="inputboxstyling mt-2 disiableState"
                                          v-model.trim="customControlObject.controlNumber"
                                          @input="v$.customControlObject.controlNumber.$touch()"
                                          placeholder="Number"
                                          disabled
                                      />
                                  </div>
                              <div class="w-6/12 leftspacing" :class="{'topspace': addpopup}">
                                          <div>
                                          <label class="controllabel">Category</label>
                                          <div> 
                                              <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlType || 'N/A'}}</div>
                                              <!-- <input
                                                  v-else
                                                  type="text"
                                                  class="inputboxstyling"
                                                  @input="v$.customControlObject.controlType.$touch()"
                                                  
                                                  v-model.trim="customControlObject.controlType"
                                                  placeholder="Type"
                                                  :class="{
                                                      'is-invalid': v$.customControlObject.controlType.$error
                                                  }"
                                              /> -->
                                                  <div>
                                                  <AutoComplete 
                                                  v-model="customControlObject.controlType"
                                                  :suggestions="filteredControlTypeOptions"
                                                  @complete="asyncFindControlType"
                                                  field="label"
                                                  :forceSelection="true"
                                                  placeholder="Category"
                                                  class="p-inputtext-sm systemsstyling  mt-2"
                                                  
                                                  />
                                              </div>

                                          <div v-if="v$.customControlObject.controlType.$error" class="text-red-500">
                                              <div v-if="v$.customControlObject.controlType && v$.customControlObject.controlType.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                          </div>
                                          </div>
                                      </div>
                                  </div>
                                  
                              </div>

                              <div class="formcontainer flex flex-col mt-3">
                                  <div class="row flex flex-row w-full">
                                      <div class="w-6/12" :class="{'topspace': addpopup}">
                                          <label class="controllabel">Family</label>
                                          <!-- <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlFamily || 'N/A'}}</div> -->
                                          <!-- <multiselect
                                              v-else
                                              v-model="customControlObject.controlFamily"
                                              :options="filteredControlFamilyOptions"
                                              :showNoOptions="false"
                                              @search-change="asyncFindControlFamily"
                                              :multiple="false"
                                              :searchable="true"
                                              open-direction="bottom"
                                              :hideArrow="false"
                                              placeholder="Family"
                                              class="custom-multiselect userSelect mt-2"
                                          >
                                              <template v-slot:noResult>
                                                  <span class="text-xs">No Families Found</span>
                                              </template>
                                          </multiselect> -->
                                              <div>
                                              <AutoComplete 
                                              v-model="customControlObject.controlFamily"
                                              :suggestions="filteredControlFamilyOptions"
                                              @complete="asyncFindControlFamily"
                                              field="label"
                                              :forceSelection="true"
                                              placeholder="Control Family"
                                              class="p-inputtext-sm systemsstyling  mt-2"
                                              :class="{ 'p-invalid': v$.customControlObject.controlFamily.$error }"
                                              />

                                              </div>
                                              <div v-if="v$.customControlObject.controlFamily.$error" class="text-red-500">
                                                  <div v-if="v$.customControlObject.controlFamily.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                              </div>
                                          
                                      </div>
                                      <div class="w-3/6 leftspacing" :class="{'topspace': addpopup}">
                                          <label class="controllabel">Class</label>
                                          <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlClass || 'N/A'}}</div>
                                          <!-- <input
                                              v-else
                                              type="text"
                                              class="inputboxstyling mt-2"
                                              @input="v$.customControlObject.controlClass.$touch()"
                                              placeholder="Class"
                                              :class="{
                                                  'is-invalid': v$.customControlObject.controlClass.$error
                                              }"
                                              v-model.trim="customControlObject.controlClass"
                                          /> -->
                                          <div v-else>
                                              <AutoComplete 
                                              v-model="customControlObject.controlClass"
                                              :suggestions="filteredControlClassOptions"
                                              @complete="asyncFindControlClass"
                                              field="label"
                                              :forceSelection="true"
                                              placeholder="Control Class"
                                              class="p-inputtext-sm systemsstyling  mt-2"
                                              />
                                              </div>
                                          <div v-if="v$.customControlObject.controlClass.$error" class="text-red-500">
                                              <div v-if="v$.customControlObject.controlClass && v$.customControlObject.controlClass.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row flex flex-row w-full mt-3" :class="{'topspace': addpopup}">
                                  <div class="w-6/12">
                                      <label class="controllabel">Owner</label>
                                      <AutoComplete
                                          v-model="controlOwnerSelection"
                                          :suggestions="filteredControlOwnerOptions"
                                          @complete="asyncFindControlOwner"
                                          @item-select="onControlOwnerPicked($event, customControlObject)"
                                          optionLabel="label"
                                          field="label"
                                          :forceSelection="true"
                                          :invalid="v$.customControlObject.controlOwner.$error"
                                          placeholder="Please select one"
                                          class="p-inputtext-sm systemsstyling mt-2 w-full"
                                      />
                                      <div v-if="v$.customControlObject.controlOwner.$error" class="text-red-500">
                                          <div class="error-text" v-if="v$.customControlObject.controlOwner.required.$invalid">Required</div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row flex flex-row w-full mt-3" :class="{'topspace': addpopup}">
                                      <div class="w-full">
                                          <label class="controllabel">Description</label>
                                          <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlDescription || 'N/A'}}</div>
                                          <textarea
                                              v-else
                                              type="text-area"
                                              class="inputboxstyling h-24 mt-2"
                                              placeholder="Description"
                                              v-model.trim="customControlObject.controlDescription"
                                              @input="v$.customControlObject.controlDescription.$touch()"
                                              :class="{
                                            'is-invalid': v$.customControlObject.controlDescription.$error
                                        }"
                                          
                                          >
                                          </textarea>
                                          <div v-if="v$.customControlObject.controlDescription.$error" class="text-red-500">
                                              <div v-if="v$.customControlObject.controlDescription && v$.customControlObject.controlDescription.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                          </div>
                                      </div>
                                  </div>

                                  <!-- <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                      <div class="w-full">
                                          <label class="controllabel">Audit Methodology</label>
                                          <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlAuditMethodology || 'N/A'}}</div>
                                          <textarea
                                              v-else
                                              type="text-area"
                                              class="inputboxstyling mt-2"
                                              @input="v$.customControlObject.controlAuditMethodology.$touch()"
                                              placeholder="Audit Methodology"
                                              v-model.trim="customControlObject.controlAuditMethodology"
                                              :class="{
                                                  'is-invalid': v$.customControlObject.controlAuditMethodology.$error
                                              }"
                                          >
                                          </textarea>
                                          <div v-if="v$.customControlObject.controlAuditMethodology.$error" class="text-red-500">
                                              <div v-if="v$.customControlObject.controlAuditMethodology && v$.customControlObject.controlAuditMethodology.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                          </div>
                                      </div>
                                  </div> -->

                                  <!-- <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                      <div class="w-full">
                                          <label class="controllabel">Audit Success Criteria</label>
                                          <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlAuditSuccessCriteria || 'N/A'}}</div>
                                          <textarea
                                              v-else
                                              type="text-area"
                                              class="inputboxstyling h-24 mt-2"
                                              placeholder="Audit Success Criteria"
                                              v-model.trim="customControlObject.controlAuditSuccessCriteria"
                                              @input="v$.customControlObject.controlAuditSuccessCriteria.$touch()"
                                              :class="{
                                                  'is-invalid': v$.customControlObject.controlAuditSuccessCriteria.$error
                                              }"
                                          >
                                          </textarea>
                                          <div v-if="v$.customControlObject.controlAuditSuccessCriteria.$error" class="text-red-500">
                                              <div v-if="v$.customControlObject.controlAuditSuccessCriteria && v$.customControlObject.controlAuditSuccessCriteria.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                          </div>
                                      </div>
                                  </div> -->

                                  <div class="row flex flex-row w-full mt-3" :class="{'topspace': addpopup}">
                                      <div class="w-full">
                                          <label class="controllabel">Tasks</label>
                                          <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlMaintenanceTask || 'N/A'}}</div>
                                          <textarea
                                              v-else
                                              type="text-area"
                                              class="inputboxstyling h-24 mt-2"
                                              placeholder="Tasks"
                                              v-model.trim="customControlObject.controlMaintenanceTask"
                                              @input="v$.customControlObject.controlMaintenanceTask.$touch()"
                                              :class="{
                                                  'is-invalid': v$.customControlObject.controlMaintenanceTask.$error
                                              }"
                                          >
                                          </textarea>
                                          <div v-if="v$.customControlObject.controlMaintenanceTask.$error" class="text-red-500">
                                              <div v-if="v$.customControlObject.controlMaintenanceTask && v$.customControlObject.controlMaintenanceTask.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="row flex flex-row w-full mt-3" :class="{'topspace': addpopup}">
                                      <div class="w-full">
                                          <label class="controllabel">Policies</label>
                                          <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlPolicies || 'N/A'}}</div>
                                          <textarea
                                              v-else
                                              type="text-area"
                                              class="inputboxstyling h-24 mt-2"
                                              placeholder="Policies"
                                              v-model.trim="customControlObject.controlPolicies"
                                              @input="v$.customControlObject.controlPolicies.$touch()"
                                              :class="{
                                            'is-invalid': v$.customControlObject.controlPolicies.$error
                                        }"
                                          
                                          >
                                          </textarea>
                                          <div v-if="v$.customControlObject.controlPolicies.$error" class="text-red-500">
                                              <div v-if="v$.customControlObject.controlPolicies && v$.customControlObject.controlPolicies.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="row flex flex-row w-full mt-3" :class="{'topspace': addpopup}">
                                      <div class="w-full">
                                          <label class="controllabel">Guidance</label>
                                          <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlGuidance || 'N/A'}}</div>
                                          <textarea
                                              v-else
                                              type="text-area"
                                              class="inputboxstyling h-24 mt-2"
                                              placeholder="Guidance"
                                              v-model.trim="customControlObject.controlGuidance"
                                              @input="v$.customControlObject.controlGuidance.$touch()"
                                              :class="{
                                            'is-invalid': v$.customControlObject.controlGuidance.$error
                                        }"
                                          
                                          >
                                          </textarea>
                                          <div v-if="v$.customControlObject.controlGuidance.$error" class="text-red-500">
                                              <div v-if="v$.customControlObject.controlGuidance && v$.customControlObject.controlGuidance.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="w-full col-md-6 mt-3" :class="{'topspace': addpopup}">
                                      <label class="controllabel">Frameworks</label>
                                      <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.frameworks[0].name || 'N/A'}}</div>
                                      
                                      <Select v-else
                                          v-model="customControlObject.controlOptionFrameWork"
                                          :options="frameWorksList"
                                          @change="getFrameworkControls(customControlObject.controlOptionFrameWork)"
                                          placeholder="Please select one"
                                          class="w-full custom-multiselect userSelect mt-2"
                                          :class="{
                                              'inputboxstylingForSelectAtPopup': customControlObject.controlOptionFrameWork === '',
                                              'stylingForInputboxstylingForSelectAtPopup': customControlObject.controlOptionFrameWork !== ''
                                          }"
                                          
                                      />
                                  </div>

                                  <div class="w-full col-md-6 mt-3" :class="{'topspace': addpopup}">
                                      <label class="controllabel">Controls</label>
                                      <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.frameworkControls || 'N/A'}}</div>
                                          <!-- <div v-else > -->
                                              <!-- <AutoComplete 
                                              v-model="customControlObject.frameworkControls"
                                              :suggestions="frameworkControls"
                                              @complete="asyncFrameworkControl"
                                              field="label"
                                              :forceSelection="true"
                                              placeholder="System Category"
                                              class="p-inputtext-sm systemsstyling  mt-2 custom-autocomplete"
                                              /> -->
                                                <div v-else>
                                                      <Select 
                                                          v-model="customControlObject.frameworkControls"
                                                          :options="frameworkControls"
                                                          :disabled="customControlObject.controlOptionFrameWork==''"
                                                          appendTo="self"
                                                          optionLabel="label" 
                                                          optionValue="id"
                                                          placeholder="Please select one"
                                                          class="w-full custom-multiselect userSelect mt-2"
                                                          :class="{
                                                              'inputboxstylingForSelectAtPopup': customControlObject.controlOptionFrameWork === '',
                                                              'stylingForInputboxstylingForSelectAtPopup': customControlObject.controlOptionFrameWork !== ''
                                                          }"
                                                      />
                                              </div>
                                          </div>

                              </div>
                          </div>
                      </div>
                  </fieldset>
              </div>
              <!-- <div  class="bottom-7 bg-white h-14 flex justify-end items-center w-full  rounded-b-sm" style="box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);">
                      <div class="buttonposition flex justify-end items-center px-5 mx-5">
                          <button @click="onCancelAllControls()" :class="customControlObject.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary mr-1.5" >Reset</button>
                          <button @click="saveControlsChangeForActivity(10301)" :disabled="clickOnButton" :class="customControlObject.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary">Active</button>
                      </div>
                  </div> -->
                  <div v-if="customPopup=true">
                    <!-- {{customControlObject}}--{{dummyCustomObj}} -->
                  <div class="border-b border-solid border-lightgrey mx-5"></div>
                      <div class="buttonposition flex justify-end items-center  pb-4 pl-5 pt-4 pr-5">
                              <button class="btnprimary mr-1.5" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton"  @click="onCancelbtnCustom('cancel')">Reset</button>
                              <button class="btnprimary" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton" @click="saveCustomControl(customControlObject)">Save</button>          
                      </div>
              </div>
              
              
      </div>
    </popup>
    <popup v-if="showPopUpForCloneControl" :popUp="showPopUpForCloneControl">
      <template v-slot:header>
        <div class="flex items-center justify-between py-4 px-2 rounded">
          <h1 class="pl-2">Clone Control</h1>
          <button class="float-right text-3xl" @click="onCancelClonebtn()">
            <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
          </button>
        </div>
      </template>
      <div class="flex flex-col h-full">
      <div class="flex-1 overflow-auto">
        <fieldset>
          <div class="flex flex-col h-full">
              <div class="flex-1 overflow-auto">
                  <fieldset :disabled="cloneControlObject._id">
                  <div>
                      <div class="statuscontainer popupbodycontainer">
                          <div class="formcontainer flex flex-col">
                              <div v-if="controlAddpopup==true" class="row flex flex-row w-full">
                                  <div class="w-full mt-3">
                                      <label class="controllabel">Source Control</label>
                                   <AutoComplete
                                      v-model="cloneControlObject.source"
                                      :suggestions="internalControlOptions"
                                      @complete="asyncFindInternalControl"
                                      @item-select="onSelectControlTitle"
                                      @clear="resetCloneControlFields"
                                      @update:model-value="checkTitleCleared"
                                      optionLabel="label"
                                      optionValue="value"
                                      field="label"  
                                      panelClass="clone-popup-panel"                                                                                             
                                      :forceSelection="true"
                                      placeholder="Source"
                                      class="p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect"
                                      :class="{ 'p-invalid': v$.cloneControlObject.source.$error }"
                                    />
                                      <div v-if="v$.cloneControlObject.source.$error" class="text-red-500">
                                          <div class="error-text" v-if="v$.cloneControlObject.source.required.$invalid">Required</div>
                                      </div>
                                  </div>
                              </div>
                              <div v-if="controlAddpopup==true" class="row flex flex-row w-full">
                                  <div class="w-full mt-3">
                                      <label class="controllabel">Control Title</label>
                                      <textarea
                                          type="text-area"
                                          class="inputboxstyling mt-2"
                                          placeholder="Control Title"
                                          :disabled="!cloneControlObject.source"
                                          @input="v$.cloneControlObject.controlTitle.$touch()"
                                          v-model.trim="cloneControlObject.controlTitle"
                                          :class="{
                                              'is-invalid': v$.cloneControlObject.controlTitle.$error,
                                              'disabled-textarea': !cloneControlObject.source
                                          }"
                                      ></textarea>
                                      <div v-if="v$.cloneControlObject.controlTitle.$error" class="text-red-500">
                                          <div class="error-text" v-if="v$.cloneControlObject.controlTitle.required.$invalid">Required</div>
                                          <div v-else-if="v$.cloneControlObject.controlTitle && v$.cloneControlObject.controlTitle.restrictCharacters100.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                      </div>
                                  </div>
                              </div>
                              <div class="flex flex-row w-full mt-3"> 
                                  <div class="w-6/12 " :class="{'topspace': controlAddpopup}">
                                      <label class="controllabel text-xs">Tier</label>
                                      <Select 
                                          v-model="cloneControlObject.categoryType"
                                          :options="tierTypes"
                                          optionLabel="value"
                                          optionValue="id"
                                          placeholder="Please select one"
                                          :disabled="!cloneControlObject.source"
                                          class="w-full custom-multiselect userSelect mt-2"
                                          @change="getTierNamesList(cloneControlObject.categoryType)"
                                          :class="{
                                           'is-invalid': v$.cloneControlObject.categoryType.$error,
                                           'inputboxstylingForSelectAtPopup': cloneControlObject.categoryType === '',
                                          }"
                                      />
                                      <div v-if="v$.cloneControlObject.categoryType.$error" class="text-red-500">
                                          <div class="error-text" v-if="v$.cloneControlObject.categoryType.required.$invalid">Required</div>
                                      </div>
                              
                                  </div>
                                  <div class="w-6/12 leftspacing" :class="{'topspace': controlAddpopup}">
                                      <label class="controllabel text-xs">Scope</label>
                                    
                                              <AutoComplete 
                                              v-model="cloneControlObject.tierTitle"
                                              :suggestions="categoryList"
                                              @complete="asyncFindForTierTitle($event, cloneControlObject.categoryType)"
                                              optionLabel="label"
                                              optionValue="value"
                                              :forceSelection="true"
                                              :disabled="cloneControlObject.categoryType==''||!cloneControlObject.source"
                                              placeholder="Type to search"
                                              class="p-inputtext-sm systemsstyling  mt-2"
                                              :class="{ 'p-invalid': v$.cloneControlObject.tierTitle.$error }"
                                              />
                                      <div v-if="v$.cloneControlObject.tierTitle.$error" class="text-red-500">
                                          <div class="error-text" v-if="v$.cloneControlObject.tierTitle.required.$invalid">Required</div>
                                      </div>
                                  </div>
                                  
                              </div>
                              <div class="flex flex-row w-full mt-3"> 
                                  <div class="w-6/12 " :class="{'topspace': controlAddpopup}">
                                      <label class="controllabel text-xs">Frequency</label>
                                     
                                      <Select 
                                          v-model="cloneControlObject.controlFrequency"
                                          :options="dbFrequency"
                                          optionLabel="key"
                                          optionValue="value"
                                          placeholder="Please select one"
                                          :disabled="!cloneControlObject.source"
                                          class="w-full custom-multiselect userSelect mt-2"
                                          :class="{
                                        'is-invalid': v$.cloneControlObject.controlFrequency.$error,
                                        'inputboxstylingForSelectAtPopup': cloneControlObject.controlFrequency === '',
                                    }"
                                      />
                                      <div v-if="v$.cloneControlObject.controlFrequency.$error" class="text-red-500">
                                          <div class="error-text" v-if="v$.cloneControlObject.controlFrequency.required.$invalid">Required</div>
                                      </div>
                              
                                  </div>
                                  <div class="w-6/12 leftspacing" :class="{'topspace': controlAddpopup}">
                                      <label class="controllabel text-xs">Priority</label>
                                      
                                          <Select
                                          v-model="cloneControlObject.controlPriority"
                                          :options="dbPriority"
                                          optionLabel="key"
                                          optionValue="value"
                                          placeholder="Please select one"
                                          class="w-full custom-multiselect userSelect mt-2"
                                          :disabled="!cloneControlObject.source"
                                          :class="{
                                                'is-invalid': v$.cloneControlObject.controlPriority.$error,
                                                'inputboxstylingForSelectAtPopup': cloneControlObject.controlPriority === '',
                                            }"
                                          
                                      />
                                      <div v-if="v$.cloneControlObject.controlPriority.$error" class="text-red-500">
                                          <div class="error-text" v-if="v$.cloneControlObject.controlPriority.required.$invalid">Required</div>
                                      </div>
                                  </div>
                                  
                              </div>
                              <!-- {{cloneControlObject.clientUniqueId}} -->
                              <div class="flex flex-row w-full mt-3">
                              <div class="w-6/12 " :class="{'topspace': controlAddpopup}">
                                      <label class="controllabel">Number</label>
                                      
                                      <div v-if="controlAddpopup==false" class="mb-3 mt-2 text-sm">{{ cloneControlObject.clientUniqueId ? cloneControlObject.clientUniqueId:cloneControlObject.controlNumber|| 'N/A'}}</div>
                                      <input
                                          type="text"
                                          class="inputboxstyling mt-2 disiableState"
                                          v-model.trim="cloneControlObject.controlNumber"
                                          placeholder="Number"
                                          disabled
                                      />
                                  </div>
                              <div class="w-6/12 leftspacing" :class="{'topspace': controlAddpopup}">
                                          <div>
                                          <label class="controllabel">Category</label>
                                          <div> 
                                              <div v-if="controlAddpopup==false" class="mb-3 mt-2 text-sm">{{ cloneControlObject.controlType || 'N/A'}}</div>
                                              
                                                  <div>
                                                  <AutoComplete 
                                                  v-model="cloneControlObject.controlType"
                                                  :suggestions="filteredControlTypeOptions"
                                                  @complete="asyncFindControlType"
                                                  field="label"
                                                  :disabled="!cloneControlObject.source"
                                                  :forceSelection="true"
                                                  placeholder="Category"
                                                  class="p-inputtext-sm systemsstyling  mt-2"
                                                  
                                                  />
                                              </div>

                                          <div v-if="v$.cloneControlObject.controlType.$error" class="text-red-500">
                                              <div v-if="v$.cloneControlObject.controlType && v$.cloneControlObject.controlType.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                          </div>
                                          </div>
                                      </div>
                                  </div>
                                  
                              </div>

                              <div class="formcontainer flex flex-col mt-3">
                                  <div class="row flex flex-row w-full">
                                      <div class="w-6/12" :class="{'topspace': controlAddpopup}">
                                          <label class="controllabel">Family</label>
                                          
                                              <div>
                                              <AutoComplete 
                                              v-model="cloneControlObject.controlFamily"
                                              :suggestions="filteredControlFamilyOptions"
                                              @complete="asyncFindControlFamily"
                                              field="label"
                                              :forceSelection="true"
                                              :disabled="!cloneControlObject.source"
                                              placeholder="Control Family"
                                              class="p-inputtext-sm systemsstyling  mt-2"
                                              :class="{ 'p-invalid': v$.cloneControlObject.controlFamily.$error }"
                                              />
                                                <div v-if="v$.cloneControlObject.controlFamily.$error" class="text-red-500">
                                                    <div v-if="v$.cloneControlObject.controlFamily && v$.cloneControlObject.controlFamily.restrictCharacters30.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                                </div>

                                              </div>
                                          
                                      </div>
                                      <div class="w-3/6 leftspacing" :class="{'topspace': controlAddpopup}">
                                          <label class="controllabel">Class</label>
                                          <div v-if="controlAddpopup==false" class="mb-3 mt-2 text-sm">{{ cloneControlObject.controlClass || 'N/A'}}</div>
                                         
                                          <div v-else>
                                              <AutoComplete 
                                              v-model="cloneControlObject.controlClass"
                                              :suggestions="filteredControlClassOptions"
                                              @complete="asyncFindControlClass"
                                              field="label"
                                              :forceSelection="true"
                                              placeholder="Control Class"
                                              :disabled="!cloneControlObject.source"
                                              class="p-inputtext-sm systemsstyling  mt-2"
                                              />
                                              </div>
                                          <div v-if="v$.cloneControlObject.controlClass.$error" class="text-red-500">
                                              <div v-if="v$.cloneControlObject.controlClass && v$.cloneControlObject.controlClass.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row flex flex-row w-full mt-3" :class="{'topspace': controlAddpopup}">
                                  <div class="w-6/12">
                                      <label class="controllabel">Owner</label>
                                      <AutoComplete
                                          v-model="controlOwnerSelection"
                                          :suggestions="filteredControlOwnerOptions"
                                          @complete="asyncFindControlOwner"
                                          @item-select="onControlOwnerPicked($event, cloneControlObject)"
                                          optionLabel="label"
                                          field="label"
                                          :disabled="!cloneControlObject.source"
                                          :forceSelection="true"
                                          :invalid="v$.cloneControlObject.controlOwner.$error"
                                          placeholder="Please select one"
                                          class="p-inputtext-sm systemsstyling mt-2 w-full"
                                      />
                                      <div v-if="v$.cloneControlObject.controlOwner.$error" class="text-red-500">
                                          <div class="error-text" v-if="v$.cloneControlObject.controlOwner.required.$invalid">Required</div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row flex flex-row w-full mt-3" :class="{'topspace': controlAddpopup}">
                                      <div class="w-full">
                                          <label class="controllabel">Description</label>
                                          <div v-if="controlAddpopup==false" class="mb-3 mt-2 text-sm">{{ cloneControlObject.controlDescription || 'N/A'}}</div>
                                          <textarea
                                              v-else
                                              type="text-area"
                                              class="inputboxstyling h-24 mt-2"
                                              placeholder="Description"
                                              v-model.trim="cloneControlObject.controlDescription"
                                              :disabled="!cloneControlObject.source"
                                              @input="v$.cloneControlObject.controlDescription.$touch()"
                                              :class="{
                                            'is-invalid': v$.cloneControlObject.controlDescription.$error,
                                            'disabled-textarea': !cloneControlObject.source
                                        }"
                                          
                                          >
                                          </textarea>
                                          <div v-if="v$.cloneControlObject.controlDescription.$error" class="text-red-500">
                                              <div v-if="v$.cloneControlObject.controlDescription && v$.cloneControlObject.controlDescription.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                          </div>
                                      </div>
                                  </div>


                                  <div class="row flex flex-row w-full mt-3" :class="{'topspace': controlAddpopup}">
                                      <div class="w-full">
                                          <label class="controllabel">Tasks</label>
                                          <div v-if="controlAddpopup==false" class="mb-3 mt-2 text-sm">{{ cloneControlObject.controlMaintenanceTask || 'N/A'}}</div>
                                          <textarea
                                              v-else
                                              type="text-area"
                                              class="inputboxstyling h-24 mt-2"
                                              placeholder="Tasks"
                                              :disabled="!cloneControlObject.source"
                                              v-model.trim="cloneControlObject.controlMaintenanceTask"
                                              @input="v$.cloneControlObject.controlMaintenanceTask.$touch()"
                                              :class="{
                                                  'is-invalid': v$.cloneControlObject.controlMaintenanceTask.$error,
                                                  'disabled-textarea': !cloneControlObject.source
                                              }"
                                          >
                                          </textarea>
                                          <div v-if="v$.cloneControlObject.controlMaintenanceTask.$error" class="text-red-500">
                                              <div v-if="v$.cloneControlObject.controlMaintenanceTask && v$.cloneControlObject.controlMaintenanceTask.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="row flex flex-row w-full mt-3" :class="{'topspace': controlAddpopup}">
                                      <div class="w-full">
                                          <label class="controllabel">Policies</label>
                                          <div v-if="controlAddpopup==false" class="mb-3 mt-2 text-sm">{{ cloneControlObject.controlPolicies || 'N/A'}}</div>
                                          <textarea
                                              v-else
                                              type="text-area"
                                              class="inputboxstyling h-24 mt-2"
                                              placeholder="Policies"
                                              :disabled="!cloneControlObject.source"
                                              v-model.trim="cloneControlObject.controlPolicies"
                                              @input="v$.cloneControlObject.controlPolicies.$touch()"
                                              :class="{
                                            'is-invalid': v$.cloneControlObject.controlPolicies.$error,
                                            'disabled-textarea': !cloneControlObject.source
                                        }"
                                          
                                          >
                                          </textarea>
                                          <div v-if="v$.cloneControlObject.controlPolicies.$error" class="text-red-500">
                                              <div v-if="v$.cloneControlObject.controlPolicies && v$.cloneControlObject.controlPolicies.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="row flex flex-row w-full mt-3" :class="{'topspace': controlAddpopup}">
                                      <div class="w-full">
                                          <label class="controllabel">Guidance</label>
                                          <div v-if="controlAddpopup==false" class="mb-3 mt-2 text-sm">{{ cloneControlObject.controlGuidance || 'N/A'}}</div>
                                          <textarea
                                              v-else
                                              type="text-area"
                                              class="inputboxstyling h-24 mt-2"
                                              placeholder="Guidance"
                                              :disabled="!cloneControlObject.source"
                                              v-model.trim="cloneControlObject.controlGuidance"
                                              @input="v$.cloneControlObject.controlGuidance.$touch()"
                                              :class="{
                                            'is-invalid': v$.cloneControlObject.controlGuidance.$error,
                                            'disabled-textarea': !cloneControlObject.source
                                        }"
                                          
                                          >
                                          </textarea>
                                          <div v-if="v$.cloneControlObject.controlGuidance.$error" class="text-red-500">
                                              <div v-if="v$.cloneControlObject.controlGuidance && v$.cloneControlObject.controlGuidance.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="w-full col-md-6 mt-3" :class="{'topspace': controlAddpopup}">
                                      <label class="controllabel">Frameworks</label>
                                      <div v-if="controlAddpopup==false" class="mb-3 mt-2 text-sm">{{ cloneControlObject.frameworks[0].name || 'N/A'}}</div>
                                      
                                      <Select v-else
                                          v-model="cloneControlObject.controlOptionFrameWork"
                                          :options="frameWorksList"
                                          @change="getFrameworkControls(cloneControlObject.controlOptionFrameWork)"
                                          placeholder="Please select one"
                                          :disabled="!cloneControlObject.source"
                                          class="w-full custom-multiselect userSelect mt-2"
                                          :class="{
                                              'inputboxstylingForSelectAtPopup': cloneControlObject.controlOptionFrameWork === '',
                                              'stylingForInputboxstylingForSelectAtPopup': cloneControlObject.controlOptionFrameWork !== ''
                                          }"
                                          
                                      />
                                  </div>

                                  <div class="w-full col-md-6 mt-3" :class="{'topspace': controlAddpopup}">
                                      <label class="controllabel">Controls</label>
                                      <div v-if="controlAddpopup==false" class="mb-3 mt-2 text-sm">{{ cloneControlObject.frameworkControls || 'N/A'}}</div>
                                       
                                                <div v-else>
                                                      <Select 
                                                          v-model="cloneControlObject.frameworkControls"
                                                          :options="frameworkControls"
                                                          :disabled="cloneControlObject.controlOptionFrameWork==''||!cloneControlObject.source"
                                                          appendTo="self"
                                                          optionLabel="label" 
                                                          optionValue="id"
                                                          placeholder="Please select one"
                                                          class="w-full custom-multiselect userSelect mt-2"
                                                          :class="{
                                                              'inputboxstylingForSelectAtPopup': cloneControlObject.controlOptionFrameWork === '',
                                                              'stylingForInputboxstylingForSelectAtPopup': cloneControlObject.controlOptionFrameWork !== ''
                                                          }"
                                                      />
                                              </div>
                                          </div>

                              </div>
                          </div>
                      </div>
                  </fieldset>
              </div>
              
          </div>
        </fieldset>
      </div>
      <div v-if="showPopUpForCloneControl=true">
        <div class="border-b border-solid border-lightgrey mx-5"></div>
          <div class="buttonposition flex justify-end items-center  pb-4 pl-5 pt-4 pr-5">
            <button class="btnprimary mr-1.5" :class="cloneControldisableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton"  @click="onCanclebtnCloneCustom('cancel')">Reset</button>
              <button class="btnprimary" :class="cloneControldisableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton" @click="saveCloneControl(cloneControlObject)">Save</button>          
        </div>
      </div>
      </div>
    </popup>
    </div>
  </div>
</template>
<style scoped>
:deep(.custom-multiselect .p-select-overlay) {
  width: 500px !important;
}

.optionColors{
   color : #4D4D4D !important;
}
.w-40{
  width:150px;
}
.multiselect-tag {
  font-size: 12px;
  font-weight: 600;
}
.multiselect-tag.is-disabled {
  background-color: #059669 !important;
}
.multiselect.is-disabled {
  background-color: white !important;
}
.tbodylast:last-child {
  border-bottom: 1px solid #e9e9e9;
}
::-webkit-scrollbar {
  width: 3px !important;
}
.borderRed {
  border: 1px solid red !important;
}
</style>
<script lang="ts">
import { emitter, toast } from "@/main";
import * as XLSX from 'xlsx';
import _ from "lodash";
import { defineComponent } from "vue";
// import loader from "../../components/loader.vue";
import { required,helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { groupBy } from "lodash";
import Multiselect from 'vue-multiselect';
import popup from "@/components/popup.vue";
import tableData from "@/components/tableData.vue";
import { requiredIf } from '@vuelidate/validators';
import toolTip from "@/components/toolTip.vue";
import { mapGetters } from "vuex";
import Select from 'primevue/select';
import AutoComplete from 'primevue/autocomplete';
const restrictCharacters100 = helpers.regex(/^[\s\S]{0,100}$/);
const restrictCharacters300 = helpers.regex(/^.{0,300}$/);
const restrictCharacters1000 = helpers.regex(/^[\s\S]{0,1000}$/);
const restrictCharacters30 = helpers.regex(/^.{0,30}$/);
export default defineComponent({
  data(): any {
    return {
        headers: [
        "_id",
        "clientUniqueId",
        "activeControlsTitle",
        "tier",
        "tierTitle",
        "controlFrequency",
        "controlOwner",
        "health",
        "KPIs",
        "status"
      ],
      isMenuVisible: false,
      filteredControlFamilyOptions:[],
      allEntityOptions:[],
      internalControlOptions:[],
      v$: useVuelidate(),
      showBlock: false,
			showDropdown: false,
      isGlobal: false,
      isAdding:false,
      isLoading: false,
      showLoader: false,
      customPopup:false,
      toolTipActive : false,
      filteredControlTypeOptions:[],
      filteredTierTitleTypeOptions:[],
      showFilters: false,
      showModal: false,
      showPopUpForCloneControl:false,
      toolTipText : '',
      internalControls:[],
      allInternalControls:[],
      dummyList: [],
      controlsList: [],
      departmentsList: [],
      selectedControlForKPI: {},
      controlFamilyArray:[],
      ControlTypeArray:[],
      kpiListForControl: [],
      selectedControl: {},
      ControlFamilyArray:[],
      departmentSelected:true,
      filters: {},
      clickOnButton: false,
      tableRow: [],
      controlFamilies:[],
      filteredControlClassOptions:[],
      filteredControlOwnerOptions:[],
      controlOwnerSelection: null,
      columnNames: {
        // controlNumber: "Control Number",
        controlTitle: "Control Title",
        controlFamily: "Control Family",
        controlClass: "Control Class",
        kpi: "KPIs",
        link: "link",
      },
      nonTableRow: [],
      allDeptOptions:[],
      columnObject: false,
      priority: ["Critical", "High", "Moderate", "Low"],
      priorityArray: [
        { label: "Very Low", id: 1 },
        { label: "Low", id: 2 },
        { label: "Moderate", id: 3 },
        { label: "High", id: 4 },
        { label: "Critical", id: 5 },
      ],
      controlArray:[],
      tierTypes:[
      { id: 10107, value: "Activity" },
      { id: 10108, value: "System" },
      { id: 10109, value: "Project" }
    ],
      editObject: {},
      editCloneControlObject:{},
      deptOptions: [],
      filteredDeptOptions: [],
      controlDepartmentArr: [],
      controlFrequency: [
				{ label: 'Daily', id: 1 },
				{ label: 'Weekly', id: 2 },
				{ label: 'Monthly', id: 3 },
				{ label: 'Quarterly', id: 4 },
				{ label: 'Semi Annualy', id: 5 },
				{ label: 'Annualy', id: 6 },
				{ label: 'Transactional', id: 7 },
			],
            
      optionsValue: [
        {
          id: 1,
          value: "KPI",
          route: "/manageKPI",
          presentRoute: "/org/controls/Information",
        },
      ],
      customControl:[],
      allEntities:[],
      frameWorksList: [],
      frameworkControls: [],
      dummyControlList:[],
      relatedFrameControls: [],
      entitiesArray:[],
      internalControlsNames: [],
      dummyCustomControl:[],
      dummyCloneCustomControl:[],
      customControlObject: {
                controlFrequency:"",
                controlNumber: "",
                controlPriority: "",
                controlTitle: "",
                controlClass: "",
                controlOwner: "",
                controlFamily: "",
                categoryType:"",
                tierTitle:"",
                controlGuidance: "",
                controlDescription:'',
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
            },
            cloneControlObject:{
                controlFrequency:"",
                controlNumber: "",
                controlPriority: "",
                source: "",
                controlTitle: "",
                controlClass: "",
                controlOwner: "",
                controlFamily: "",
                categoryType:"",
                tierTitle:"",
                controlGuidance: "",
                controlDescription:'',
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
            },
      dummyCustomObj:{},
      dummycloneControlObject:{},
      controlObject: {
        controlFrequency:"",
        // controlNumber: "",
        controlPriority: "",
        controlTitle: "",
        controlClass: "",
        controlFamily: "",
        controlGuidance: "",
        controlAuditMethodology: "",
        controlAuditSuccessCriteria: "",
        controlMaintenanceTask: "",
        controlPolicies: "",
        controlType: "",
        departments: [],
        // entity:'',
        controlOptionFrameWork: '',
				frameworkControls: '',
        allProjects:[]
      },
      
      dataLoading:true,
      optionsUserArray:[],
      allControlsList:[],
      users:[],
      fullKeys:['departments', 'controlTitle', 'controlGuidance', 'controlClass', 'controlFamily', 'controlType', 'controlPriority', 'controlFrameWork'],
      systems:{},
      activitiesList: [],
      categoryList:[],
      allSystemList:[],
      allActivityList:[],
      allProjectList:[],
      controlClassArray:[]
    };
  },
 validations(){
        return{
          customControlObject:
          {
            controlTitle: { required ,restrictCharacters100},
            categoryType:{required},
            tierTitle:{required},
            controlFrequency: { required },
            controlPriority:{ required },
            controlOwner: { required },
            controlClass: { restrictCharacters300 },
            controlFamily: { restrictCharacters300 },
            controlDescription:{restrictCharacters1000},
            controlGuidance: { restrictCharacters1000 },
            controlAuditMethodology: { restrictCharacters300 },
            controlAuditSuccessCriteria: { restrictCharacters300 },
            controlMaintenanceTask: { restrictCharacters1000 },
            controlPolicies: { restrictCharacters1000 },
            controlType: { restrictCharacters300 },
          },
          cloneControlObject:
          {
            source: { required },
            controlTitle: { required ,restrictCharacters100},
            categoryType:{required},
            tierTitle:{required},
            controlFrequency: { required },
            controlPriority:{ required },
            controlOwner: { required },
            controlClass: { restrictCharacters300 },
            controlFamily: { restrictCharacters300 },
            controlDescription:{restrictCharacters1000},
            controlGuidance: { restrictCharacters1000 },
            controlAuditMethodology: { restrictCharacters300 },
            controlAuditSuccessCriteria: { restrictCharacters300 },
            controlMaintenanceTask: { restrictCharacters1000 },
            controlPolicies: { restrictCharacters1000 },
            controlType: { restrictCharacters300 },
          },
			controlObject:{
				departments:{required},
        // entity:{
        //   required: requiredIf(() => {
				// 		return (this.controlObject.entitytypecodeid == 20303);
				// 	})
        // },
        // controlNumber: { required },
        controlTitle: { required },
        controlFrequency: { required },
				frameworkControls:{
					required: requiredIf(() => {
						return Object.keys(this.controlObject).includes('controlOptionFrameWork') && this.controlObject.controlOptionFrameWork != '';
					})
				},
				
			},
        }
    },
  
  components: {
    // loader,
    popup,
    Multiselect,
    tableData,
    toolTip,
    Select,
    AutoComplete
  },
  async mounted() {
     emitter.off('activeControlPopup')
	  this.bindRowClickListeners();
    document.addEventListener('click', this.handleClickOutside);

    // 		await this.orgFetchControlsInfo();

    await this.getAllControls();
    	emitter.on('*', (type, booleanValue) => {
			if (type == 'apps-sidemenubar' || type == 'toggle-sidebar') {
				this.showBlock == true ? ((this.showBlock = false), (this.showDropdown = false)) : '';
			} 
      else if( type == 'deActiviteToolTip' || type == 'activiteToolTip'){
        return ;
      }
      else {
				if (this.showBlock == true) {
					if (this.showDropdown == false) {
						this.showDropdown = true;
					} else {
						this.showDropdown = false;
						this.showBlock = false;
					}
				} else {
					this.showDropdown = false;
				}
			}
		});
	  // emitter.off("activeControlPopup");
    // emitter.on("activeControlPopup", (isData: any) => {
    //   let comingId = isData.entityData._id;
    //   let showObj = this.allControlsList.find((obj: any) => {
    //     return obj._id === comingId;
    //   });
    //   this.showEditPopUp(showObj, isData.indexx);
    // });
    emitter.on('close-dropdown',()=>{this.showBlock = false}) 
    emitter.off('detailsModalClosed');
    emitter.on('detailsModalClosed', this.refreshAfterDetailsModal);
  },
  beforeUnmount() {
    emitter.off('detailsModalClosed', this.refreshAfterDetailsModal);
    document.removeEventListener('click', this.handleClickOutside);
	if (this.onActiveControlPopup) {
		emitter.off('activeControlPopup', this.onActiveControlPopup);
	}
  },
  async created() {
    this.dataLoading = true;
    await this.getAllUsers();
    await this.getAllInternalControls(),
    // await this.getallEntities();
    await this.fetchActivitiesList();
    await this.getAllSystems();
    await this.getAllProjects();
    await this.allActiveControls();
    await this.getInternalControls();
    // await this.fetchDepartmentsList();
    // await this.fetchControlsInfo();
    emitter.off('activiteToolTip');
    emitter.on('activiteToolTip', (data: any) => {
        this.toolTipActive = true;
        this.toolTipText = data.tipText
    });
    emitter.off('deActiviteToolTip');
    emitter.on('deActiviteToolTip', (data: any) => {
        this.toolTipActive = false;
        this.toolTipText = ''
    });
    this.dataLoading = false;
  },
  computed:{
        ...mapGetters({
            userInfo: 'userInfo',
            dbPriority:'dbPriority',
            dbFrequency:'dbFrequency'
        }),
    disableStatus: function (): any {
			let disableStatusCondition;
            if(this.customControlObject._id){
                if (JSON.stringify(this.customControlObject) == JSON.stringify(this.dummyCustomObj)) {
					disableStatusCondition = false;
				} else {
					disableStatusCondition = true;
				}
            }else{
                let val: any = [];
                Object.values(this.customControlObject).forEach((value: any) => {
                    val.push(value);
                });
                for (let n of val) {
                    if (n != '' && n!=this.customControlObject.controlNumber) {
                        disableStatusCondition = true;
                    }
                }
            }

			return disableStatusCondition;
		},
    cloneControldisableStatus: function (): any {
			let disableCloneControlStatusCondition;
            if(this.cloneControlObject._id){
                if (JSON.stringify(this.cloneControlObject) == JSON.stringify(this.dummycloneControlObject)) {
					disableCloneControlStatusCondition = false;
				} else {
					disableCloneControlStatusCondition = true;
				}
            }else{
                let val: any = [];
                Object.values(this.cloneControlObject).forEach((value: any) => {
                    val.push(value);
                });
                for (let n of val) {
                    if (n != '' && n != null && !(Array.isArray(n) && n.length == 0) && n!=this.cloneControlObject.controlNumber) {
                        disableCloneControlStatusCondition = true;
                    }
                }
            }

			return disableCloneControlStatusCondition;
		},
    

  },
  methods: {
  toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
    asyncFind(query:any){
      if(query == ''){
          this.allDeptOptions = []
      }else if(query.length >= 1){
          this.allDeptOptions = this.filteredDeptOptions.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
      }
    },
    asyncFindInternalControl(query:any){
      query = query.query.trim();
      if(query == ''){
          this.internalControlOptions = []
      }else if(query.length >= 1){
          this.internalControlOptions = this.internalControls.filter((obj:any)=>{
            return obj.label.toLowerCase().includes(query.toLowerCase())})
      }
    },
    onSelectControlTitle(event: any) {

      const selectedId = event.value.value;

      const selectedControl = this.allInternalControls.find(
         (control: any) => control._id === selectedId
      );

      if (!selectedControl) return;

      this.cloneControlObject.controlTitle = selectedControl.controlTitle;
      this.cloneControlObject.controlType = selectedControl.controlType;
      this.cloneControlObject.controlFamily = selectedControl.controlFamily;
      this.cloneControlObject.controlClass = selectedControl.controlClass;
      this.cloneControlObject.controlOwner = selectedControl.controlOwner;
      this.setControlOwnerSelection(selectedControl.controlOwner);
      this.cloneControlObject.controlDescription = selectedControl.Description;
      this.cloneControlObject.controlMaintenanceTask = selectedControl.controlMaintenanceTask;
      this.cloneControlObject.controlPolicies = selectedControl.controlPolicies;
      this.cloneControlObject.controlGuidance = selectedControl.controlGuidance;
      this.cloneControlObject.controlFrequency = selectedControl.controlFrequency;
      this.cloneControlObject.controlPriority = selectedControl.controlPriority;

    // if (selectedControl.frameworks?.length) {
    //   this.cloneControlObject.frameworks = selectedControl.frameworks;
    // }
    if(selectedControl.frameworks!=undefined && selectedControl.frameworks.length>0) {
      this.cloneControlObject.controlOptionFrameWork = selectedControl.frameworks[0].name;
      let frameworkControlsData = this.getFrameworkControls(selectedControl.frameworks[0].name)
      this.cloneControlObject.frameworkControls = selectedControl.frameworks[0].controls[0];
      this.dummyCloneCustomControl={...this.cloneControlObject}

      }
  },
    asyncFindForTierTitle(event: any, categoryType: any) {

  const query = event.query.trim().toLowerCase();

  if (!query) {
    this.categoryList = [];
  }
  else if (categoryType == 10108) {
    this.categoryList = this.allSystemList.filter((obj: any) =>{
      return obj.label.toLowerCase().includes(query)
  });
  }
  else if (categoryType == 10109) {
    this.categoryList = this.allProjectList.filter((obj: any) =>
      obj.label.toLowerCase().includes(query)
    );
  }
  else if (categoryType == 10107) {
    this.categoryList = this.allActivityList.filter((obj: any) =>
      obj.label.toLowerCase().includes(query)
    );
  }

  this.v$.$reset();
},
    asyncFindControlType(query:any) { 
                 
            query = query.query.trim();
            if (query == '') {
                    this.filteredControlTypeOptions = [];
            } else {
              
                this.filteredControlTypeOptions = this.ControlTypeArray.filter((item:any) => 
                    item?.toLowerCase().includes(query.toLowerCase())
                );
                let isNewOption = !this.ControlTypeArray.some((item:any) => 
                    item?.toLowerCase() === query.toLowerCase()
                );
                
                if (isNewOption && query !== '') {
                    this.filteredControlTypeOptions.push(query);
                }
            }
            
        },
        handleClickOutside(event:any) {
          const menuContainer = this.$refs.menuContainer;
          if (menuContainer && !menuContainer.contains(event.target)) {
            this.isMenuVisible = false;
          }
        },
        asyncFindDepartment(query:any){
        if(query == ''){
            this.allDeptOptions = []
        }else if(query.length >= 1){
            let finalDept:any=[];
            let presentEntity:any = this.allEntities.find((obj:any)=>{return obj._id == this.createObjective.entity?.value;})
            if(presentEntity != undefined &&(presentEntity.departments != undefined || presentEntity.entityType==1) &&  presentEntity.entityType!=3&&presentEntity.entityType!=2) {
              let filterDepts:any = this.uniqueDeptOptions.filter((obj:any)=>{return presentEntity.departments?.includes(obj.value) || obj.type==20301;});
                filterDepts.map((obj:any)=>{
                  let a = {value:obj.value,label:obj.label};
                  finalDept.push(a)
                })
            }
            if(presentEntity != undefined && presentEntity.departments != undefined && presentEntity.type!=1 &&(presentEntity.entityType==3 || presentEntity.entityType==2)){
              let filterDepts:any = this.uniqueDeptOptions.filter((obj:any)=>{return presentEntity.departments.includes(obj.value);});
              filterDepts.map((obj:any)=>{
                let a = {value:obj.value,label:obj.label};
                finalDept.push(a)
              })
            }
            this.allDeptOptions = finalDept.filter((obj: any) => {
              return obj.label.toLowerCase().includes(query.toLowerCase());
            });
        }
    },
    checkTitleCleared(value: any) {
      if (value) {
        return;
      }
      this.resetCloneControlFields();
    },
    resetCloneControlFields() {
      const controlNumber = this.cloneControlObject.controlNumber;
      this.cloneControlObject.controlTitle = '';
      this.cloneControlObject.controlType = '';
      this.cloneControlObject.controlFamily = '';
      this.cloneControlObject.controlClass = '';
      this.cloneControlObject.controlDescription = '';
      this.cloneControlObject.controlMaintenanceTask = '';
      this.cloneControlObject.controlPolicies = '';
      this.cloneControlObject.controlGuidance = '';
      this.cloneControlObject.controlFrequency = '';
      this.cloneControlObject.controlPriority = '';
      this.cloneControlObject.controlOptionFrameWork = '';
      this.cloneControlObject.frameworkControls = '';
      this.cloneControlObject.frameworks = [];
      this.cloneControlObject.categoryType = '';
      this.cloneControlObject.tierTitle = '';
      this.cloneControlObject.controlNumber = controlNumber;
      if (this.cloneControlObject.source) {
        this.cloneControlObject.source = '';
      }
      this.v$.cloneControlObject.$reset();
    },
        asyncFindTierTitleType(query:any) { 
                 
            query = query.query.trim();
            if (query == '') {
                    this.filteredTierTitleTypeOptions = [];
            } else {
              
                this.filteredTierTitleTypeOptions = this.ControlTierTitleArray.filter((item:any) => 
                    item?.toLowerCase().includes(query.toLowerCase())
                );
                let isNewOption = !this.ControlTierTitleArray.some((item:any) => 
                    item?.toLowerCase() === query.toLowerCase()
                );
                
                if (isNewOption && query !== '') {
                    this.filteredTierTitleTypeOptions.push(query);
                }
            }
            
        },
        asyncFindControlClass(query:any) {      
            query = query.query.trim();            
            if (query == '') {
                    this.filteredControlClassOptions = [];
            } else {
                this.filteredControlClassOptions = this.controlClassArray.filter((item:any) => 
                    item?.toLowerCase().includes(query.toLowerCase())
                );
                
                let isNewOption = !this.controlClassArray.some((item:any) => 
                    item?.toLowerCase() === query.toLowerCase()
                );
                if (isNewOption && query !== '') {
                    this.filteredControlClassOptions.push(query);
                }
            }
        },
        
    selectedOption(opt:any){
      let isNewOption = !this.ControlFamilyArray.includes(opt);
      isNewOption==true ? this.ControlFamilyArray.push(opt) : ''
    },
    asyncFind2(query:any){
      if(query == ''){
          this.allEntityOptions = []
      }else if(query.length >= 1){
          this.allEntityOptions = this.entitiesOptions.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
      }
    },
    async customPopupPopup(){
            this.v$.$reset();
            this.customPopup = true;
            this.controlOwnerSelection = null;
            this.addpopup=true;
            this.customControlObject = {
                controlFrequency:"",
                controlNumber: "",
                controlPriority: "",
                controlTitle: "",
                controlClass: "",
                controlOwner: "",
                controlFamily: "",
                controlGuidance: "",
                categoryType:"",
                tierTitle:"",
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
            }
            // let id = uuidv4();
            // const truncatedUuid = id.replace(/-/g,'').substring(0, 8)
            // this.customControlObject.controlNumber = truncatedUuid.toUpperCase();
            // this.dummyCustomObj.controlNumber = truncatedUuid.toUpperCase();
            let w= await this.incrementAndAddCC();            
            this.customControlObject.controlNumber = w;  
            this.dummyCustomControl.controlNumber=w;
        },
        async showpopupOnAddCloneControl(){
            this.v$.$reset();
            this.showPopUpForCloneControl = true;
            this.controlOwnerSelection = null;
            this.controlAddpopup=true;
            this.cloneControlObject = {
                controlFrequency:"",
                controlPriority: "",
                source: "",
                controlTitle: "",
                controlClass: "",
                controlOwner: "",
                controlFamily: "",
                controlGuidance: "",
                categoryType:"",
                tierTitle:"",
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
            }
            let controlId= await this.incrementAndAddCC();     
            this.cloneControlObject.controlNumber = controlId;  
            this.dummyCloneCustomControl.controlNumber=controlId;
            // let id = uuidv4();
            // const truncatedUuid = id.replace(/-/g,'').substring(0, 8)
            // this.customControlObject.controlNumber = truncatedUuid.toUpperCase();
            // this.dummyCustomObj.controlNumber = truncatedUuid.toUpperCase();
            
        },
        
        async incrementAndAddCC() {
            const maxCCNumber = this.customControl.reduce((max: number, item: any) => {
                if (typeof item === 'string' && item.startsWith('CC-')) {
                const num = parseInt(item.split('-')[1]);
                if (!isNaN(num)) {
                    return Math.max(max, num);
                }
                }
                return max;
            }, 0);        
            const nextNumber = maxCCNumber + 1;
            const newCC = `CC-${nextNumber}`;
            return newCC;
        },
        // /api/org/control/:controlId/kpis/select
      async getAllInternalControls() {
      const res = await this.$http.get(
      `${process.env.VUE_APP_CONTROLS_API}/api/org/internalcontrols/get`
     );

     this.allInternalControls = res.data;
     let allControls = res.data;
        this.internalControls=[];
        for (var i = 0; i < allControls.length; i++) {
            this.internalControls.push({ label:allControls[i].controlTitle, value:allControls[i]._id });
        }
   },
        async getInternalControls() {
			this.tabDataLoading = true
            this.totalOrgControls = [];
            try{
            let resultofFramework = await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/tenant/org/controls/get`);
            let allIC = await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/allControls?frameWork=InternalControls`);
            let new1 = resultofFramework.data;
            let new2 = allIC.data;
            if(new1!=undefined && new1.length>0 && new2!=undefined && new2.length>0){
                let activeFramework = new1.find((n:any)=>n.frameWorkName=='InternalControls' && n.isActive==true);
                if(activeFramework!=undefined){
                    new2.forEach((n1:any)=>{
                        // if(n1.classificationType==10603){
                        //     this.customControl.push(n1.controlNumber)
                        // }
                    })
                    
                }                
            }
            }catch (e) {
				toast.error(`Something went wrong`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
      this.tabDataLoading = false
		},
    getProirityLabel(val:any){
        if (val === 'N/A') { 
            return ''; 
        } else {
            let a = this.dbPriority.find((obj: any) => obj.value == val);
            return (val && typeof val === 'number') ? a.key : '';
        }
    },
    onCancelbtnCustom(prop:any){
            this.v$.$reset();
            if (prop === 'close') {
              this.customPopup=false;
              
			}
            if(prop=='cancel'){
              //  this.customControlObject={}
              // this.dummyCustomControl={}
              if(this.customControlObject._id){
               this.customControlObject={...this.dummyCustomControl}
              }else{
                 Object.keys(this.customControlObject).forEach((prop) => {
                Array.isArray(this.customControlObject[prop])
                    ? (this.customControlObject[prop] = [])
                    : (this.customControlObject[prop] = "");
                });
                this.customControlObject.controlNumber = this.dummyCustomControl.controlNumber
              }
              
            }
        },
        onCanclebtnCloneCustom(data:any){
          this.v$.$reset();
            if (data === 'close') {
              this.showPopUpForCloneControl=false;
			     }
           if(data=='cancel'){
              //  this.customControlObject={}
              // this.dummyCustomControl={}
              if(this.cloneControlObject._id){
               this.cloneControlObject={...this.dummyCloneCustomControl}
              }else{
                 Object.keys(this.cloneControlObject).forEach((prop) => {
                Array.isArray(this.cloneControlObject[prop])
                    ? (this.cloneControlObject[prop] = [])
                    : (this.cloneControlObject[prop] = "");
                });
                this.cloneControlObject.controlNumber = this.dummyCloneCustomControl.controlNumber
              }
              
            }
        },
    toHealthBucket(healthPercent: number) {
      // const value = healthPercent / 4;
      if (healthPercent >= 0 && healthPercent <= 20) {
        return 1;
      } else if (healthPercent > 21 && healthPercent <= 40) {
        return 2;
      } else if (healthPercent > 41 && healthPercent <= 60) {
        return 3;
      } else if (healthPercent > 61 && healthPercent <= 80) {
        return 4;
      } else if (healthPercent > 81 && healthPercent <= 100) {
        return 5;
      }
    },
    normalizeControlHealth(stored: any) {
      if (stored == null || stored === '') {
        return 'N/A';
      }
      const numeric = Number(stored);
      if (Number.isNaN(numeric)) {
        return 'N/A';
      }
      return numeric > 5 ? this.toHealthBucket(numeric) : numeric;
    },
    async allActiveControls(frameName: any) {
        await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/controls`).then((res: any) => {
            this.allControlsList = res.data;
        });
        this.tableRow = []
        this.allControlsList.map((control: any) => {            
          let keysOfObject:any = Object.keys(control)   
          let ObjectIncludedTier:any
          let tierLabelObj:any
          let tierTitle:any
          // let priority:any = this.getProirityLabel(control.controlPriority)
          let kpisLength:any
          let owner:any = this.optionsUserArray.find((user:any)=>{return user.value == control.controlOwner})
          if(control.classificationType==10603) {
            this.customControl.push(control.controlNumber)
          }
          if(owner == undefined || owner == '' || owner == null){
            owner = 'N/A'
          } else{
            owner = owner.label
          }
          if(keysOfObject.includes('activityId')){
            ObjectIncludedTier = 10107            
            if(this.activitiesList.length>0 && control.activityId!=undefined){
                let matchedActivity = this.activitiesList.find((activity:any)=>activity._id.toString()==control.activityId.toString());                
                if(matchedActivity!=undefined){
                    tierTitle = matchedActivity.businessProcessName
                }
            }            

          } else if(keysOfObject.includes('systemId')){
            ObjectIncludedTier = 10108
            if(this.systems.length>0 && control.systemId!=undefined){
                let matchedSystem = this.systems.find((sys:any)=>sys._id.toString()==control.systemId.toString());
                if(matchedSystem!=undefined){
                  
                    tierTitle = matchedSystem.systemName
                }
            }
          } else if(keysOfObject.includes('projectId')){
            ObjectIncludedTier = 10109
            if(this.allProjects.length>0 && control.projectId!=undefined){
                let matchedProject = this.allProjects.find((project:any)=>project._id.toString()==control.projectId.toString());
                if(matchedProject!=undefined){
                    tierTitle = matchedProject.projectName
                }
            }
          }
          else {
            ObjectIncludedTier ='N/A'
          }
          tierLabelObj = this.tierTypes.find((t:any) =>{ 
            return t.id == ObjectIncludedTier
            
            // return t.value
            });
          if(Array.isArray(control.kpis)){
            let kpiData = control.kpis.filter((kpi:any)=> kpi && kpi.isActive==true)
            kpisLength = kpiData.length;
          } else {
            kpisLength = 0
          }      
          let obj:any = {
            _id: control._id,
            clientUniqueId: control.clientUniqueId != undefined || control.clientUniqueId != '' ? control.clientUniqueId :'N/A',
            activeControlsTitle: control.controlTitle != undefined || control.controlTitle != '' ? control.controlTitle : 'N/A',
            tier: tierLabelObj != undefined && tierLabelObj != '' ? tierLabelObj.id : 'N/A',
            tierTitle:tierTitle!=undefined && tierTitle!=''?tierTitle:'N/A',
            controlFrequency:control.controlFrequency!=undefined|| control.controlFrequency!=''?control.controlFrequency:'N/A',
            controlOwner: control.owner != undefined || control.owner != '' ? owner : 'N/A',
            status:control.isActive==true?1:2,
            controlPriority: control.controlPriority != undefined || control.controlPriority != '' ? control.controlPriority : 'N/A',
            health: this.normalizeControlHealth(control.controlHealth),
            KPIs: kpisLength != undefined || kpisLength != '' ? kpisLength : 'N/A',
          }
          this.tableRow.push(obj)
          this.controlTypeArray=[]
          // this.controlFamilyArray=[]
          // this.controlClassArray=[]
          // if (Object.keys(data).includes('controlFamily') && (data.controlFamily != "" || data.controlFamily != null || data.controlFamily != undefined) && !this.controlArray.includes(data.controlFamily)) {
          //                   this.controlArray.push(data.controlFamily);
          //               }
          
          if (Object.keys(control).includes('controlFamily') && (control.controlFamily != "" || control.controlFamily != null || control.controlFamily != undefined) && !this.controlFamilyArray.includes(control.controlFamily)) {
                            this.controlFamilyArray.push(control.controlFamily);
                        }

                        if (Object.keys(control).includes('controlType') && (control.controlType != "" || control.controlType != null || control.controlType != undefined ) && control.controlType!='N/A'&& !this.ControlTypeArray.includes(control.controlType)) {
                            this.ControlTypeArray.push(control.controlType);
                        }
                        if (Object.keys(control).includes('controlClass') && (control.controlClass != "" || control.controlClass != null || control.controlClass != undefined) && !this.controlClassArray.includes(control.controlClass)) {                            
                            this.controlClassArray.push(control.controlClass);
                        } 
        });
		},
    getTierNamesList(data:any){
      this.categoryList =[];
      this.customControlObject.tierTitle=''
      this.cloneControlObject.tierTitle=''
      if(data==10108){
        this.categoryList=this.allSystemList;
      }
      else if(data==10107){
        this.categoryList=this.allActivityList;
      }
      else if(data==10109){
        this.categoryList=this.allProjectList;
      }
			
      this.v$.$reset();},
    async getAllUsers() {
        await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
            this.users = res.data;
        });
        for (var i = 0; i < this.users.length; i++) {
            this.optionsUserArray.push({ label: this.users[i].name, value: this.users[i]._id });
        }
    },
    manageKpiAction(data:any){
      emitter.emit('openDetailsModal', {
        view: 'manageKPI',
        title: data.controlTitle || data.title || 'Control',
        params: { controlId: data._id, type: 10102 },
      });
		},
    async refreshAfterDetailsModal() {
      await this.allActiveControls();
	  this.bindRowClickListeners();
    },
	bindRowClickListeners() {
		if (this.onActiveControlPopup) {
			emitter.off('activeControlPopup', this.onActiveControlPopup);
		}
		this.onActiveControlPopup = (isData: any) => {
			let data = isData.entityData;
			this.manageKpiAction(data);
		};
		emitter.on('activeControlPopup', this.onActiveControlPopup);
	},
    async getAllSystems() {
        let entityId='20005'
        await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${entityId}`).then((res: any) => {
            this.systems = res.data;
        });
        this.systems.map((system:any)=>{
            if(system.isActive==true){
              this.allSystemList.push({label:system.systemName,value:system._id})
            }
        })
        // let systemId:any = this.$route.params.systemId
        // let data:any = this.systems.find((data:any)=>{
        //     return data._id == systemId
        // })
        // // console.log('Data');
        
        // this.systemObj = {...data}
    },
    async getAllProjects(){
			this.projectDataArray = [],
			this.dataLoading = true;
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/projects/getAll`).then((res: any) => {
				this.allProjects = res.data;
  })
  this.allProjects.map((project:any)=>{
          this.allProjectList.push({label:project.projectName,value:project._id})
        })
  },
     async fetchActivitiesList() {
        try {
            await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/processes/mappedcontrols/count`).then((res: { data: any }) => {
                this.activitiesList = res.data;
                // if (this.activitiesList.length > 0) {
                //     this.presentActivityObj = this.departmentsList.find((activity: any) => {return activity._id == this.$route.params.id});
                // }
            });
            this.activitiesList.map((activity:any)=>{
          this.allActivityList.push({label:activity.businessProcessName,value:activity._id})
        })
        } catch (e) {
            toast.error('error', {
                timeout: 1000,
                closeOnClick: true,
                closeButton: 'button',
                icon: true
            });
        }
        this.showLoader = false;
    },
    async getallEntities() {
      this.entitiesOptions = [];
      let result: any;
      await this.$http
        .get(
          `${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`
        )
        .then((res: any) => {
          result = res.data;
          this.allEntities = res.data;
        });
      for (var i = 0; i < result.length; i++) {
        this.entitiesArray.push({
          label: result[i].entityName,
          value: result[i]._id,
        });
      }
    },
    asyncFindControlFamily(query:any) {
        query =query.query.trim();
        if (query == '') {
				this.filteredControlFamilyOptions = [];
			} else {
				this.filteredControlFamilyOptions = this.controlFamilyArray.filter((item:any) => 
					item?.toLowerCase().includes(query.toLowerCase())
				);
				let isNewOption = !this.controlFamilyArray.some((item:any) => 
					item?.toLowerCase() === query.toLowerCase()
				);
				if (isNewOption && query !== '') {
					this.filteredControlFamilyOptions.push(query);
				}
			}
        // // let isNewOption = !this.ControlFamilyArray.includes(query);
        // let isNewOption = !(this.ControlFamilyArray.some((item:any) => {return item?.toLowerCase().includes(query.toLowerCase())}))

  	    // if(isNewOption == true && query !=''){
        //   // this.ControlFamilyArray.push(query);
        //   this.filteredControlFamilyOptions=[]
        //   this.filteredControlFamilyOptions.push(query)
        // }else if (query == '') {
        //     this.filteredControlFamilyOptions = [];
        // } else if (query.length > 1) {
        //     this.filteredControlFamilyOptions = this.ControlFamilyArray.filter((item:any) => {return item?.toLowerCase().includes(query.toLowerCase())});
        // }
    },
    // addCustomTag(newTag:any) {
      // if (!this.filteredControlFamilyOptions.includes(newTag)) {
        // this.filteredControlFamilyOptions.push(newTag);
      // }
    // },
    getControlNumberAndTitle(name: any){
      const result: any = Object.values(this.jsonArray).flatMap(x => x).find((y: any) => y.controlNumber === name);
      if (result) {
        return `${result.controlNumber}--${result.controlTitle}`;
      }
    },
    getFrameworkControls(name:any){
      // this.controlObject.frameworkControls = '';
      this.frameworkControls=[];
      if(this.jsonArray != undefined){
        let array=Object.values(this.jsonArray)
        array.forEach((x:any)=>{
          x.forEach((y:any)=>{
            if(y.controlFrameWork == name){
              this.frameworkControls.push({ label: `${y.controlNumber}` + `--` + `${y.controlTitle }`, id:`${y._id}` })
            }
          })
        })
      }
		},
    async getAllControls(frameName: any) {
			emitter.emit('visible', false);
			this.showFilters = false;
			try {
				this.isLoading = false;
				const result = await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/allControls`);
				this.isLoading = true;
				this.columnObject = false;
				this.rowData = result.data;
				//  jsonArray: any = [];
				let arr: any = [];
        if((this.rowData != null || this.rowData != undefined) && this.rowData.length != 0){
          this.rowData.forEach((item: any) => {
            if (item.controlFrameWork && item.controlNumber && Object.keys(item).includes('controlFrameWork') && Object.keys(item).includes('controlNumber') && !Object.keys(item).includes('isInternalControl')) {
              arr.push(item);
              this.jsonArray = this.groupByFrameworks(arr);
            }
          });
          // let array=Object.values(this.jsonArray)
          // array.forEach((data:any)=>{
          // 	data.forEach(())
          // })
          
          let displayFrameName = '';	
          if(this.jsonArray != undefined){
            this.frameWorksList = [];
            Object.keys(this.jsonArray).forEach((key, index) => {
              if (frameName === index) {
                displayFrameName = key;
              }
              this.frameWorksList.push(key);
            });
          }
          // Object.values(jsonArray).forEach((value, index) => {
          // 	this.frameworkControls = value
          // 	// if (frameName === index) {
          // 	// 	displayFrameName = key;
          // 	// }
          // 	// this.frameWorksList.push({value: index, displayName: key });
          // });

          // this.frameworkControls = [];
          // this.frameworkControls = arr
          //   .filter((control: any) => control.controlFrameWork && control.controlFrameWork === displayFrameName)
          //   .map(
          //     (control: any) => ({ value: control._id, label: control.controlNumber + control.controlTitle })
          //     // .push({value: control._id, label: control.controlNumber + control.controlTitle})
          //   );
        }
			} catch (e) {
				this.isLoading = false;
				toast.error(`Something went wrong`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
		},
    groupByFrameworks(arr: any[]) {
			return arr.reduce((group: any, product: any) => {
				const { controlFrameWork } = product;
				group[controlFrameWork] = group[controlFrameWork] ?? [];
				group[controlFrameWork].push(product);
				return group;
			}, {});
		},
    	addControls() {
			// (this.controlObject.controlFrameWork = ''),
			// 	(this.controlObject.controlMapFrameWork = ''),
			// 	(this.controlObject.controlNumber = ''),
			// 	(this.controlObject.controlPriority = ''),
			// 	(this.controlObject.controlTitle = ''),
			// 	(this.controlObject.controlClass = ''),
			// 	(this.controlObject.controlFamily = ''),
			// 	(this.controlObject.controlGuidance = ''),
			// 	(this.controlObject.controlAuditMethodology = ''),
			// 	(this.controlObject.controlAuditSuccessCriteria = ''),
			// 	(this.controlObject.controlMaintenanceTask = ''),
			// 	(this.controlObject.controlPolicies = ''),
			// 	(this.controlObject.controlType = ''),
			// 	(this.controlObject.controlFrequency = '');
			// 	this.controlObject.controlOptionFrameWork='';
			// 	this.controlObject.frameworkControls=[];

			this.v$.$reset();
			// this.editObject = {};
			Object.keys(this.controlObject).forEach((prop) => {
				this.controlObject[prop] = '';
			});
			Object.keys(this.editObject).forEach((prop) => {
				this.editObject[prop] = '';
			});
      // if(this.controlObject._id){
        delete this.controlObject._id;
      // }
			this.showModal = true;
		},
    getControlFrequency(id:any){
      if(id != undefined || id != '' || id != null){
        let frequency:any = this.dbFrequency.find((data:any)=>{return data.value == id})
        return frequency.key
      } else {
        return 'N/A'
      }
    },
    getControlOwnerName(id:any){
      let owner:any = this.optionsUserArray.find((user:any)=>{return user.value == id})
      if(owner == undefined || owner == '' || owner == null){
        return 'N/A'
      }
      return owner.label
    },
    asyncFindControlOwner(event:any){
      const query = (event?.query || '').trim().toLowerCase();
      this.filteredControlOwnerOptions = this.optionsUserArray.filter((user:any) =>
        query === '' || (user.label || '').toLowerCase().includes(query)
      );
    },
    controlOwnerOption(id:any){
      if (id && typeof id === 'object' && id.label) {
        return id;
      }
      if (id === undefined || id === null || id === '') {
        return null;
      }
      return this.optionsUserArray.find((user:any) => String(user.value) === String(id)) || null;
    },
    setControlOwnerSelection(id:any){
      const owner = this.controlOwnerOption(id);
      this.controlOwnerSelection = owner;
      this.filteredControlOwnerOptions = owner ? [owner] : [...this.optionsUserArray];
    },
    onControlOwnerPicked(event:any, target:any){
      const selected = event?.value;
      if (!selected || typeof selected !== 'object') {
        return;
      }
      this.controlOwnerSelection = selected;
      if (target) {
        target.controlOwner = selected.value;
      }
    },
    onCancelbtn(status: any) {
      // this.showModal = false;
			this.v$.$reset();
			this.showBlock = false;
			if (status === 'close') {
				Object.keys(this.controlObject).forEach((prop) => {
          Array.isArray(this.controlObject[prop])
            ? (this.controlObject[prop] = [])
            : (this.controlObject[prop] = "");
        });
        delete this.controlObject._id
				this.showModal = false;
			} else if (status == 'cancel') {
       Object.keys(this.controlObject).forEach((prop) => {
          Array.isArray(this.controlObject[prop])
            ? (this.controlObject[prop] = [])
            : (this.controlObject[prop] = "");
        });
				this.controlObject = { ...this.editObject };
       
        
			}
      this.isGlobal = false;
		},
    onCancelClonebtn() {
      // this.showModal = false;
			this.v$.$reset();
			this.showPopUpForCloneControl = false;
			
       Object.keys(this.cloneControlObject).forEach((prop) => {
          Array.isArray(this.cloneControlObject[prop])
            ? (this.cloneControlObject[prop] = [])
            : (this.cloneControlObject[prop] = "");
        });
       
        
      this.isGlobal = false;
		},
    async updateControl(controlObject: any) {
			this.v$.$touch();
			if (!this.v$.$invalid) {
        this.clickOnButton = true;
        let copyOfControlObject:any = {...controlObject}
				// let uniqueControlNumber = this.dummyControlList.some((item: any) => item.controlNumber === copyOfControlObject.controlNumber);

				// if (uniqueControlNumber) {
					this.showModal = false;
          this.isGlobal = false
					let objId = copyOfControlObject._id;
          if(copyOfControlObject.controlOptionFrameWork && copyOfControlObject.frameworkControls){
            let arr = []
            let frameWork
            if(copyOfControlObject.controlOptionFrameWork){
              frameWork = copyOfControlObject.controlOptionFrameWork
            }
            
            // let controls = copyOfControlObject.frameworkControls
            let controls 
            if(copyOfControlObject.frameworkControls){
              let parts = copyOfControlObject.frameworkControls.split("--");
              controls = parts[0];
            }
            delete copyOfControlObject.frameworkControls
            delete copyOfControlObject.controlOptionFrameWork
            let obj = {
              framework: frameWork,
              controls: [controls]
            }
            arr.push(obj)
            copyOfControlObject.frameworks = arr
          }
          copyOfControlObject.departments = copyOfControlObject.departments.value
          if(this.controlObject.entitytypecodeid == 20303){
             copyOfControlObject.entity = copyOfControlObject.entity.value
          }
					// delete copyOfControlObject._id;
					try {
						await this.$http.post(`${process.env.VUE_APP_CONTROLS_API}/api/org/controlset/update/${objId}`, _.omit(copyOfControlObject, ['_id'])).then((result: any) => {
							toast.info(`Updated Successfully`, {
								timeout: 1000,
								closeOnClick: true,
								closeButton: 'button',
								icon: true
							});
						});
					} catch (e) {
						toast.error(`Something went wrong`, {
							timeout: 1000,
							closeOnClick: true,
							closeButton: 'button',
							icon: true
						});
					}finally {
              this.clickOnButton = false;
          }
          this.v$.$reset();
					await this.fetchControlsInfo();
				// } else {
				// 	this.showModal = false;
				// 	toast.error(`Control Number should be unique`, {
				// 		timeout: 1000,
				// 		closeOnClick: true,
				// 		closeButton: 'button',
				// 		icon: true
				// 	});
				// }
			}
		},
    async orgFetchControlsInfo() {
			this.controlsList = [];
			this.showLoader = true;
			this.isLoading = false;
			await this.$http
				.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/allControls?frameWork=InternalControls`)
				.then((result: { data: any }) => {
					this.isLoading = true;
					this.showLoader = false;
					result.data.forEach((item: any) => {
						if (item.isInternalControl) {
							this.controlsList.push(item);
						}
					});
          this.editObject = {...this.controlObject}
				})
				.catch((error: any) => {
					this.isLoading = false;
					(this.showLoader = false),
						toast.error(`Save failed with ${error}`, {
							timeout: 1000,
							closeOnClick: true,
							closeButton: 'button',
							icon: true
						});
				});
			//this.makeTable();
		},
    async saveCustomControl(controlObject: any) {
			this.v$.$touch();
			if (!this.v$.customControlObject.$invalid) {
				// let uniqueControlNumber: any;
				// uniqueControlNumber = this.dummyControlList.some((item: any) => item.controlNumber === controlObject.controlNumber);
				let arr = []
        let frameWork
        if(controlObject.controlOptionFrameWork){
          frameWork = controlObject.controlOptionFrameWork
        }
          if(controlObject.categoryType==10108){
            controlObject.systemId=controlObject.tierTitle.value
          }
          if(controlObject.categoryType==10107){
            controlObject.activityId=controlObject.tierTitle.value
          }if(controlObject.categoryType==10109){
            controlObject.projectId=controlObject.tierTitle.value
          }
          // let controls = controlObject.tierTitle.value
          let controls 
          // controlObject.tier = controlObject.tierTitle          
        if(controlObject.frameworkControls){
          let parts = controlObject.frameworkControls.split("--");
          controls = parts[0];
        }
				delete controlObject.frameworkControls
				delete controlObject.controlOptionFrameWork
        if(frameWork != "" && controls != ""){
          let obj = {
					  name: frameWork,
            controls: [controls]
          }
          arr.push(obj)
          controlObject.frameworks = arr
        }
				// if (uniqueControlNumber == false) {
					this.showModal = false;
					let payload;
					let framework = 'InternalControls';
          const { tierTitle, ...controlObjectData } = controlObject;
					payload = {
						controlFrameWork: framework,
						controlsList: [{ ...controlObjectData, isInternalControl: true }]
					};

				  try{
                await this.$http.post(`${process.env.VUE_APP_MONITOR_API}/api/org/control/create`,[payload]).then(async (res: { data: any }) => {
                    let cameIds:any = []
                    let result:any;

                    cameIds.push(res.data.insertedIds);
                    const tierData: any = {
                        10108: 'systemId',
                        10107: 'activityId',
                        10109: 'projectId'
                      };
                    const tierName = tierData[controlObject.categoryType];
                    const tierValue = controlObject[tierName];
                    if(cameIds.length > 0){
                      const newPayload = [{
                        [tierName]: tierValue,
                        controlIds: cameIds,
                        createdBy: this.userInfo._id,
                        createdAt: new Date()
                      }];
                        await this.$http.post(`${process.env.VUE_APP_MONITOR_API}/api/org/active/control/create`,newPayload).then(async (res: { data: any }) => {
                            result = res.data;
                            toast.info('Saved', {
                                timeout: 1000,
                                closeOnClick: true,
                                closeButton: 'button',
                                icon: true
                            });
                            this.onCancelbtnCustom('close')
                            await this.getInternalControls();
                            await this.allActiveControls();
                        })
                        await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/active/controls/tasks/create`,[result]).then(async (res: { data: any }) => {
                            //console.log('result',res.data); 
                        })
                    }
                  });
              }catch(e:any){
                if(e.response.status==403){
                    toast.error(`${e.response.data.error}`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                  });
                }
                else{
                    toast.error('error', {
                  timeout: 1000,
                  closeOnClick: true,
                  closeButton: 'button',
                  icon: true
                });
                }
              }finally {
                this.clickOnButton = false;
              }
                }
              },
              
    // async saveCustomControl(controlObject: any) {
		// 	this.v$.$touch();
		// 	if (!this.v$.controlObject.$invalid) {
    //     this.clickOnButton = true;
    //     let copyOfControlObject: any = {...controlObject}
    //     console.log("copyOfControlObject", copyOfControlObject)
		// 		let uniqueControlNumber: any;
		// 		// uniqueControlNumber = this.dummyControlList.some((item: any) => item.controlNumber === copyOfControlObject.controlNumber);
    //     if ((this.dummyControlList != undefined || this.dummyControlList != null) && this.dummyControlList.length != 0) {
    //       // uniqueControlNumber = this.dummyControlList.some((control: any) => {
    //       //   console.log("control", control)
    //       //   if(copyOfControlObject.departments.type == 20301 && control.departments == copyOfControlObject.departments.value){
    //       //     console.log("33333333")
    //       //     return control.controlNumber == copyOfControlObject.controlNumber;
    //       //   } else {
    //       //     console.log("11111111")
    //       //     if(control.departments == copyOfControlObject.departments.value && control.entity == copyOfControlObject.entity){
    //       //       console.log("22222222")
    //       //       return control.controlNumber == copyOfControlObject.controlNumber;
    //       //     }
    //       //   }
    //       // });
    //       uniqueControlNumber = this.dummyControlList.some((control: any) => {
    //         // console.log("control", control);
            
    //         const isDepartmentMatch = control.departments == copyOfControlObject.departments.value;
    //         const isControlNumberMatch = control.controlNumber == copyOfControlObject.controlNumber;

    //         if (copyOfControlObject.departments.type === 20301) {
    //             console.log("Checking for type 20301");
    //             return isDepartmentMatch && isControlNumberMatch;
    //         } else if (copyOfControlObject.departments.type === 20303){
    //             console.log("Checking for type 20303");
    //             return isDepartmentMatch && control.entity == copyOfControlObject.entity && isControlNumberMatch;
    //         }
    //     });

    //     }
		// 		let arr = []
    //     let frameWork
    //     if(copyOfControlObject.controlOptionFrameWork){
    //       frameWork = copyOfControlObject.controlOptionFrameWork
    //     }
		// 		copyOfControlObject.entity = copyOfControlObject.entity == 'Global'? 'global' : copyOfControlObject.entity.value
		// 		// let controls = copyOfControlObject.frameworkControls
    //     let controls 
    //     if(copyOfControlObject.frameworkControls){
    //       let parts = copyOfControlObject.frameworkControls.split("--");
    //       controls = parts[0];
    //     }
		// 		delete copyOfControlObject.frameworkControls
		// 		delete copyOfControlObject.controlOptionFrameWork
    //     if(frameWork != "" && controls != ""){
    //       let obj = {
		// 			  framework: frameWork,
    //         controls: [controls]
    //       }
    //       arr.push(obj)
    //       copyOfControlObject.frameworks = arr
    //     }
    //     console.log("uniqueControlNumber", uniqueControlNumber)
		// 		if (uniqueControlNumber == false) {
		// 			this.showModal = false;
    //       this.isGlobal = false;
		// 			let payload;
		// 			let framework = 'InternalControls';
		// 			payload = {
		// 				controlFrameWork: framework,
		// 				controlsList: [{ ...copyOfControlObject, isInternalControl: true }]
		// 			};
		// 			await this.addControlSource([payload], 'toast', copyOfControlObject);
		// 		} else {
		// 			this.showModal = false;
    //       this.isGlobal = false;
		// 			toast.error(`Control Number should be unique`, {
		// 				timeout: 1000,
		// 				closeOnClick: true,
		// 				closeButton: 'button',
		// 				icon: true
		// 			});
		// 		}
		// 	}
		// },
async saveCloneControl(cloneControlObject: any) {
    this.v$.$touch();
    if (!this.v$.cloneControlObject.$invalid) {
        this.showPopUpForCloneControl = false;
        if(cloneControlObject.source!=undefined){
          cloneControlObject.controlId = cloneControlObject.source.value
        }
        delete cloneControlObject.source;
        const typeId = cloneControlObject.categoryType;
        const tierData: any = { 10108: 'system', 10107: 'activity', 10109: 'project' };
        const tierName = tierData[typeId];
        const tierId = cloneControlObject.tierTitle.value;
        let newPayload:any=[];
        cloneControlObject.frameworks = [
			   {
				"name":cloneControlObject.controlOptionFrameWork,
				"controls":[cloneControlObject.frameworkControls]
			   }
      ]

      cloneControlObject.isInternalControl = true
      delete cloneControlObject.controlOptionFrameWork
      delete cloneControlObject.frameworkControls

      cloneControlObject.createdAt = new Date().toISOString();
      cloneControlObject.createdBy = this.userInfo._id.toString();
      // if(cloneControlObject.tierTitle!=undefined){
      //   cloneControlObject.tierTitle = cloneControlObject.tierTitle.value
      // }
      delete cloneControlObject.tierTitle
      await this.$http.post(`${process.env.VUE_APP_CONTROLS_API}/type/${typeId}/${tierName}/${tierId}/control/clone`,cloneControlObject).then(async (res: { data: any }) => {
        newPayload.push(res.data.insertedId)
        try {
            toast.info('Saved');
            this.onCanclebtnCloneCustom('close');
            await this.getAllInternalControls()
            await this.getInternalControls();
            await this.allActiveControls();
            await this.getAllControls();

        } catch (e: any) {
            toast.error(e.response?.data?.error);
        } finally {
            this.clickOnButton = false;
        }
    })
    await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/active/controls/tasks/create`,newPayload).then(async (res: { data: any }) => {
                            //console.log('result',res.data); 
                        })
    }
    
},
    
    async addControlSource(payload: any, action: any, controlObject: any) {
			try {
        // let departmentId = controlObject.departments
        payload[0].controlsList.forEach((obj: any)=>{
          obj.controlNumber = ''
          delete obj.departments
          delete obj.entity
        })
        delete payload.frameworkControls
				delete payload.controlOptionFrameWork
        // this.rowData.map((obj:any) =>{
        //   if(obj.controlNumber){
        //     this.internalControlsNames.push(JSON.stringify(obj.controlNumber).toLowerCase())
        //   }
        // })
        // console.log("internalControlsNames", this.internalControlsNames)
        // if(this.internalControlsNames.includes(JSON.stringify(payload[0].controlsList[0].controlNumber).toLowerCase())){
        //   console.log("iiiinnnnnnnnnnn")
        //   let controlRouteId = this.rowData.find((obj: any)=>{return payload[0].controlsList[0].controlNumber == obj.controlNumber})
        //   console.log("controlRouteId",controlRouteId)
        //   let payloadForControlIds: any = [];
        //   let departmentRouteId = controlObject.departments;
        //   // let selectedTeamObjs: any = this.departmentsList.filter((obj: any)=>{
        //   //   return obj._id == controlObject.entity
        //   // })
        //   let departmentRouteObj = this.departmentsList.find((obj: any)=>{
        //     return obj._id == departmentRouteId.value
        //   })
        //   console.log("departmentRouteObj111111111", departmentRouteObj)
        //   if(departmentRouteObj.entityType == 20301){
        //     payloadForControlIds = [
        //       {
        //         departmentId: departmentRouteId.value,
        //         // entityId: entityRouteId,
        //         entitytypecodeid: 20301,
        //         controlIds: [controlRouteId._id]
        //       }
        //     ];
        //   } else {
        //     payloadForControlIds = [
        //       {
        //         departmentId: departmentRouteId.value,
        //         entityId: departmentRouteObj.entityId,
        //         entitytypecodeid: 20303,
        //         controlIds: [controlRouteId._id]
        //       }
        //     ];
        //   }
        //   await this.$http.post(`${process.env.VUE_APP_CONTROLS_API_URL}/api/org/controls/manageDepartments`, payloadForControlIds).then(() => {
              
        //   });
        //   if (action == 'toast') {
        //       toast.info(`Saved Successfully`, {
        //         timeout: 1000,
        //         closeOnClick: true,
        //         closeButton: 'button',
        //         icon: true
        //       });
        //     }
        // } else {
          await this.$http.post(`${process.env.VUE_APP_CONTROLS_API}/api/org/controlset/create`, payload).then(async (result: any) => {
            let payloadForControlIds: any = [];
            let controlRouteId: any[] = [];
            controlRouteId = result.data.insertedIds[0];
            let departmentRouteId = controlObject.departments;
            // let entityRouteId = controlObject.entity;
            let departmentRouteObj = this.departmentsList.find((obj: any)=>{
              return obj._id == departmentRouteId.value
            })
            if(departmentRouteObj.entityType == 20301){
              payloadForControlIds = [
                {
                  departmentId: departmentRouteId.value,
                  // entityId: entityRouteId,
                  entitytypecodeid: 20301,
                  controlIds: [controlRouteId]
                }
              ];
            } else {
              payloadForControlIds = [
                {
                  departmentId: departmentRouteId.value,
                  entityId: departmentRouteObj.entityId,
                  entitytypecodeid: 20303,
                  controlIds: [controlRouteId]
                }
              ];
            }
            await this.$http.post(`${process.env.VUE_APP_CONTROLS_API}/api/org/controls/manageDepartments`, payloadForControlIds).then(() => {
              
            });
            if (action == 'toast') {
              toast.info(`Saved Successfully`, {
                timeout: 1000,
                closeOnClick: true,
                closeButton: 'button',
                icon: true
              });
            }
          })
        // }
        await this.fetchControlsInfo();
        await this.makeTable();
			} catch (e) {
				toast.error(`Something went wrong`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}finally {
          this.clickOnButton = false;
      }
		},
    showEditPopUp(data: any, index: any) {
      let keysOfObject:any = Object.keys(data)
        let ObjectIncludedTier:any
        let kpisLength:any
        let owner:any = this.optionsUserArray.find((user:any)=>{return user.value == data.owner})
        if(owner == undefined || owner == '' || owner == null){
          data.owner = 'N/A'
        } else{
          data.owner = owner.label
        }
        if(keysOfObject.includes('activityId')){
          ObjectIncludedTier = 'Activity'
        } else if(keysOfObject.includes('systemId')){
          ObjectIncludedTier = 'System'
        } else {
          ObjectIncludedTier ='N/A'
        }
        if(Array.isArray(data.kpis)){
          kpisLength = data.kpis.length
        } else {
          kpisLength = 0
        }
        this.getFrameworkControls(data.frameworks[0].name)
        let framework:any 
        let frameworkControlMap:any
        if(data.frameworks && data.frameworks != undefined){
            data.frameworks.map((frameworkObj:any) => {
                framework = frameworkObj
            });
            this.frameworkControls.map((control:any)=>{
                frameworkControlMap = control
            })
            data.controlOptionFrameWork = framework.framework != undefined ? framework.framework : ''
            data.frameworkControls = frameworkControlMap != undefined || frameworkControlMap != null ? frameworkControlMap :''
        }
        // let obj:any = {
        //   clientUniqueId: data.clientUniqueId != undefined || data.clientUniqueId != '' ? data.clientUniqueId :'N/A',
        //   controlTitle: data.controlTitle != undefined || data.controlTitle != '' ? data.controlTitle : 'N/A',
        //   tier: ObjectIncludedTier != undefined || ObjectIncludedTier != '' ? ObjectIncludedTier : 'N/A',
        //   controlOwner: data.owner != undefined || data.owner != '' ? owner : 'N/A',
        //   controlPriority: data.controlPriority != undefined || data.controlPriority != '' ? data.controlPriority : '',
        //   KPIs: kpisLength != undefined || kpisLength != '' ? kpisLength : 'N/A',
        // }
      this.controlObject = { ...data };
      this.editObject = { ...this.controlObject };
      this.showModal = true;
    },
    openFileModal() {
      this.$router.push({ name: 'controlsImport' });
			// this.$refs.file.click();
			// this.showBlock = false;
		},
    makeTable() {
      this.tableRow = [];
      if (this.controlsList.length > 0) {
        this.controlsList.forEach((item: any) => {
          const kpisLength = Array.isArray(item.kpis) ? item.kpis.length : 0;
          let frameName;
          let tableObj:any
          frameName = (item.frameworks != undefined && item.frameworks.length != 0) ? item.frameworks[0].framework : "N/A";
          let deptName = this.departmentsList.find((eachdepartment: any) => {return item.departments == eachdepartment._id});
          let owner :any
          if(deptName != undefined){
            owner = this.optionsUserArray.find((user:any)=>{return user.value == deptName.teamOwner})
          }
          let entityName:any
          if(deptName && deptName.entityType == 20301){
            entityName = 'Global'
          }
          else if (deptName && deptName.entityType == 20303){
              entityName = deptName.entityName != undefined ? deptName.entityName : 'N/A'
          }
          tableObj = {
            _id: item._id,
            departments: deptName != undefined ? deptName.teamName : 'N/A',
            frameWork: frameName ? frameName : 'N/A',
            cCID: item.clientUniqueId != undefined ? item.clientUniqueId : 'N/A',
            activeControlsTitle: item.controlTitle  != undefined ? item.controlTitle : 'N/A',
            Class: item.controlClass ? item.controlClass : 'N/A',
            owner: owner != undefined ? owner.label : 'N/A',
            KPIs: kpisLength,
            Entity: entityName != undefined ? entityName : 'N/A' 
          }
          this.tableRow.push(tableObj);
          this.dataLoading = false;
        });

        this.columnObject = false;
      } else {
        this.columnObject = true;
        // this.tableRow.push({
        //   _id: "",
        //   departments: "",
        //   frameWork: "",
        //   cCID: "",
        //   activeControlsTitle: "",
        //   Class: "",
        //   "KPIs": "",
        // });
      }
    },
    fileReader(oEvent: any): any {
			var oFile = oEvent.target.files[0];
			var reader = new FileReader();
			reader.onload = async (e: any) => {
				let data: any = e.target.result;
				data = new Uint8Array(data);
				var workbook = XLSX.read(data, { type: 'array' });
				var first_sheet_name = workbook.SheetNames[0];
				var worksheet = workbook.Sheets[first_sheet_name];
				var jsonObj = XLSX.utils.sheet_to_json(worksheet, {
					raw: true,
					header: this.fullKeys,
					range: 1
				});

				let total = jsonObj.length;
				let valid = 0;
				const jsonArray: any = [];
				let framework = '';
				const uniqueControlNumbers = new Set<string>();
				let booleanValue = true;
				for (let i = 0; i < jsonObj.length; i++) {
					let item: any;
					item = jsonObj[i];
					let arr = ['departments', 'controlNumber', 'controlFamily', 'controlClass', 'controlTitle', 'controlPriority', 'controlType'];
					let mandatoryCondition = arr.every((key: any) => {
						return Object.keys(item).includes(key) && item[key];
					});
					let PriorityObj = this.priorityArray.find((obj: any) => {
						return obj.label == item.controlPriority;
					});
					item.controlPriority = PriorityObj.id;

					// let TypeObj = this.controlTypeArray.find((obj: any) => {
					// 	return obj.label == item.controlType;
					// });
					// item.controlType = TypeObj.id;
          let controlCheck
          if((this.dummyControlList != undefined || this.dummyControlList != null) && this.dummyControlList.length > 0){
            controlCheck = this.dummyControlList.some((control: any)=>{
              return control.controlNumber === item.controlNumber
            })
          }
          let deptId = this.departmentsList.find((obj: any) => {
            return obj.teamName === item.departments
					});
          if(deptId != undefined || deptId != null){
            item.departments = deptId._id;
          }
					if (mandatoryCondition && (deptId != undefined || deptId != null) && !controlCheck) {
						if (!uniqueControlNumbers.has(item.controlNumber)) {
							booleanValue = false;
							framework = 'InternalControls';
							// objectArr.push(item);
              jsonArray[item.departments] = jsonArray[item.departments] || [];
							jsonArray[item.departments].push(item);
							uniqueControlNumbers.add(item.controlNumber);
						}
					}
				}
				if (booleanValue) {
					toast.error(`Control Number should be unique`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
				}
				let controlSets: any = [];
				let controlsFinal: any = [];
				Object.keys(jsonArray).forEach((key) => {
					// const temp = {
					// 	controlFrameWork: framework,
					  jsonArray[key].map((item: any) => {
              controlsFinal.push({ ...item, isInternalControl: true })
            });
					// };
					valid = valid + controlsFinal.length;
					
				});
        const temp = {
          controlFrameWork: framework,
          controlsList: controlsFinal
        };
        controlSets.push(temp);
				// this.addControl = true;
				await this.addControlSource(controlSets, 'toast');
				if (controlSets.length > 0) {
					toast.info(`Imported ${total} rows, Valid rows: ${valid}, Ignored rows: ${total - valid}`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
				} else {
					toast.error(`Something went wrong`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
				}
			};
			reader.readAsArrayBuffer(oFile);
		},
    async fetchControlsInfo() {
      this.controlsList = [];
      this.tableRow = [];
      this.dataLoading = true;
      this.dummyList = [];
      this.showLoader = true;
      await this.$http
        .get(`${process.env.VUE_APP_CONTROLS_API}/api/org/controls/active`)
        .then((result: { data: any }) => {
          this.isLoading = true;
          this.showLoader = false;
          // _.each(
          //   result.data,
          //   (control: { department: any; departments: string | any[] }) => {
          //     // if (control.departments.length > 0) {
          //     //   _.each(control.departments, (dept: any) => {
          //     //     control.department = dept;
          //     //   });
          //     // }
          //     let updatedObject = Object.assign({}, control);
          //     controlList.push(updatedObject);
          //   }
          // );
          this.controlsList = result.data;
          this.dummyControlList = [...result.data];
          this.familyData = result.data.filter((obj: any) => {
            return Object.keys(obj).includes("controlFamily");
          });
          const groupedControlsFamily = groupBy(
            this.familyData,
            "controlFamily"
          );
          const listOfFamily = Object.keys(groupedControlsFamily);
          listOfFamily.forEach((key) => {
            if (key != "" || key != null || key != undefined) {
              this.ControlFamilyArray.push(key);
            }
          });
          this.dummyList = {...this.controlsList};
        })
        .catch((error: any) => {
          this.isLoading = false;
          (this.showLoader = false),
            this.$toasted.error(error, {
              theme: "toasted-primary",
              duration: 1000,
            });
        });
      await this.makeTable();
    },
    async fetchDepartmentsList() {
      this.showLoader = true;
      await this.$http
        .get(`${process.env.VUE_APP_ORG_API}/departments/get`)
        .then((res: { data: any }) => {
          this.isLoading = true;
          this.showLoader = false;
//           res.data = [
//     {
//         "_id": "66fbe72919c32f06aaaa5276",
//         "teamName": "Development Team",
//         "displayName": "Development Team 1",
//         "entityType": 20303,
//         "teamOwner": "66d4a36360fe55695a7212f3",
//         "entityId": "66f6ac8996fa7ac24639ad23",
//         "entityName": "My Entity 1",
//         "entityDisplayName": "MyEntity1",
//         "entityOwner": "6226dcaaf974bdd1169d5d85"
//     },
//     {
//         "_id": "66fbe72919c32f06aaaa5277",
//         "teamName": "Development Team",
//         "displayName": "Development Teamm",
//         "entityType": 20303,
//         "teamOwner": "66dadbed60fe55695a721337",
//         "entityId": "66f6acbf96fa7ac24639ad24",
//         "entityName": "My Entity 2",
//         "entityDisplayName": "MyEntity2",
//         "entityOwner": "6226dcaaf974bdd1169d5d85"
//     },
//     {
//         "_id": "66fbea9819c32f06aaaa5279",
//         "teamName": "Information Tech",
//         "displayName": "IT",
//         "entityType": 20303,
//         "teamOwner": "64e2fbf7bc8473611a0df291",
//         "entityId": "66f4f7d94ecb1064f6cec2cc",
//         "entityName": "Mannelabs Goa",
//         "entityDisplayName": "Goa Entity",
//         "entityOwner": "66d4a36360fe55695a7212f3"
//     },
//     {
//         "_id": "66fbea9819c32f06aaaa527a",
//         "teamName": "Information Tech",
//         "displayName": "IT",
//         "entityType": 20303,
//         "teamOwner": "64e2fbf7bc8473611a0df291",
//         "entityId": "66f4f79d4ecb1064f6cec2cb",
//         "entityName": "Mannelabs-BNGLR",
//         "entityDisplayName": "Mannelabs-BNGLR",
//         "entityOwner": "66de792260fe55695a72134c"
//     },
//     {
//         "_id": "66fbf97419c32f06aaaa527b",
//         "teamName": "Global Team",
//         "displayName": "Global Ux",
//         "entityType": 20301,
//         "globalHead": "64e2fbf7bc8473611a0df291",
//         "type": 20301
//     },
//     {
//         "_id": "66fe2716b706952aeddf113e",
//         "teamName": "Testing Team",
//         "displayName": "QA Test",
//         "entityType": 20303,
//         "teamOwner": "66d4a36360fe55695a7212f3",
//         "entityId": "66f6ac8996fa7ac24639ad23",
//         "entityName": "My Entity 1",
//         "entityDisplayName": "MyEntity1",
//         "entityOwner": "6226dcaaf974bdd1169d5d85"
//     },
//     {
//         "_id": "66fe2716b706952aeddf113f",
//         "teamName": "Testing Team",
//         "displayName": "QA Test",
//         "entityType": 20303,
//         "teamOwner": "66c6bec260fe55695a7212a2",
//         "entityId": "66f6acbf96fa7ac24639ad24",
//         "entityName": "My Entity 2",
//         "entityDisplayName": "MyEntity2",
//         "entityOwner": "6226dcaaf974bdd1169d5d85"
//     },
//     {
//         "_id": "66fe2ab5b706952aeddf1140",
//         "teamName": "Team Testing",
//         "displayName": "TESTING",
//         "entityType": 20301,
//         "globalHead": "66c6bec260fe55695a7212a2",
//         "type": 20301
//     },
//     {
//         "_id": "66fe2ae3b706952aeddf1141",
//         "teamName": "Team Security",
//         "displayName": "Security",
//         "entityType": 20303,
//         "teamOwner": "6226dcaaf974bdd1169d5d85",
//         "entityId": "66f4f7664ecb1064f6cec2ca",
//         "entityName": "Mannelabs Hyd",
//         "entityDisplayName": "Mannelabs Hyd",
//         "entityOwner": "6226dcaaf974bdd1169d5d85"
//     },
//     {
//         "_id": "66fe2ae3b706952aeddf1142",
//         "teamName": "Team Security",
//         "displayName": "Security",
//         "entityType": 20303,
//         "teamOwner": "6226dcaaf974bdd1169d5d85",
//         "entityId": "66f4f7d94ecb1064f6cec2cc",
//         "entityName": "Mannelabs Goa",
//         "entityDisplayName": "Goa Entity",
//         "entityOwner": "66d4a36360fe55695a7212f3"
//     },
//     {
//         "_id": "66fe2ae3b706952aeddf1143",
//         "teamName": "Team Security",
//         "displayName": "Security",
//         "entityType": 20303,
//         "teamOwner": "66d4a36360fe55695a7212f3",
//         "entityId": "66f4f8064ecb1064f6cec2cd",
//         "entityName": "Mannelabs Delhi",
//         "entityDisplayName": "Delhi Entity",
//         "entityOwner": "66c6bec260fe55695a7212a2"
//     },
//     {
//         "_id": "66fe2ae3b706952aeddf1144",
//         "teamName": "Team Security",
//         "displayName": "Security",
//         "entityType": 20303,
//         "teamOwner": "6226dcaaf974bdd1169d5d85",
//         "entityId": "66f4f82a4ecb1064f6cec2ce",
//         "entityName": "Mannelabs Sydney",
//         "entityDisplayName": "Sydney mannelabs",
//         "entityOwner": "66de792260fe55695a72134c"
//     },
//     {
//         "_id": "66fe2ae3b706952aeddf1145",
//         "teamName": "Team Security",
//         "displayName": "Security",
//         "entityType": 20303,
//         "teamOwner": "6226dcaaf974bdd1169d5d85",
//         "entityId": "66f4f79d4ecb1064f6cec2cb",
//         "entityName": "Mannelabs-BNGLR",
//         "entityDisplayName": "Mannelabs-BNGLR",
//         "entityOwner": "66de792260fe55695a72134c"
//     },
//     {
//         "_id": "66fe2ae3b706952aeddf1146",
//         "teamName": "Team Security",
//         "displayName": "Security",
//         "entityType": 20303,
//         "teamOwner": "6226dcaaf974bdd1169d5d85",
//         "entityId": "66f4fb674ecb1064f6cec2d5",
//         "entityName": "Mannelabs Chennai",
//         "entityDisplayName": "Chennai",
//         "entityOwner": "66de792260fe55695a72134c"
//     },
//     {
//         "_id": "66fe2d00b706952aeddf1147",
//         "teamName": "Cyber",
//         "displayName": "Crystalline",
//         "entityType": 20301,
//         "globalHead": "66c6bec260fe55695a7212a2"
//     },
//     {
//         "_id": "66fe2d77b706952aeddf1148",
//         "teamName": "Team 1",
//         "displayName": "TEAM",
//         "entityType": 20303,
//         "teamOwner": "6226dcaaf974bdd1169d5d85",
//         "entityId": "66f4f7664ecb1064f6cec2ca",
//         "entityName": "Mannelabs Hyd",
//         "entityDisplayName": "Mannelabs Hyd",
//         "entityOwner": "6226dcaaf974bdd1169d5d85"
//     },
//     {
//         "_id": "66fe2d77b706952aeddf1149",
//         "teamName": "Team 1",
//         "displayName": "TEAM11",
//         "entityType": 20303,
//         "teamOwner": "66d4a36360fe55695a7212f3",
//         "entityId": "66f4f7d94ecb1064f6cec2cc",
//         "entityName": "Mannelabs Goa",
//         "entityDisplayName": "Goa Entity",
//         "entityOwner": "66d4a36360fe55695a7212f3"
//     },
//     {
//         "_id": "6703593cb706952aeddf1152",
//         "teamName": "Testing Team",
//         "displayName": "Manual Testing",
//         "entityType": 20303,
//         "teamOwner": "66c6bec260fe55695a7212a2",
//         "entityId": "670358eab706952aeddf1151",
//         "entityName": "Testing_Test",
//         "entityDisplayName": "Test1",
//         "entityOwner": "66c6bec260fe55695a7212a2"
//     },
//     {
//         "_id": "67036a6db706952aeddf1156",
//         "teamName": "Development Team",
//         "displayName": "My Entity 1",
//         "entityType": 20303,
//         "teamOwner": "66c6bec260fe55695a7212a2",
//         "entityId": "66f4f7d94ecb1064f6cec2cc",
//         "entityName": "Mannelabs Goa",
//         "entityDisplayName": "Goa Entity",
//         "entityOwner": "66d4a36360fe55695a7212f3"
//     },
//     {
//         "_id": "67036a6db706952aeddf1157",
//         "teamName": "Development Team",
//         "displayName": "My Entity 1",
//         "entityType": 20303,
//         "teamOwner": "66c6bec260fe55695a7212a2",
//         "entityId": "66f4f7664ecb1064f6cec2ca",
//         "entityName": "Mannelabs Hyd",
//         "entityDisplayName": "Mannelabs Hyd",
//         "entityOwner": "6226dcaaf974bdd1169d5d85"
//     },
//     {
//         "_id": "67036a98b706952aeddf1158",
//         "teamName": "Development Team",
//         "displayName": "Development Team",
//         "entityType": 20301,
//         "globalHead": "66c6bec260fe55695a7212a2"
//     }
// ]
          this.departmentsList = res.data;
        })
        .catch((error: any) => {
          this.isLoading = false;
          (this.showLoader = false),
            toast.error(`Save failed with ${error}`, {
              timeout: 1000,
              closeOnClick: true,
              closeButton: "button",
              icon: true,
            });
        });
      this.deptOptions = this.departmentsList.map((item: any) => {
        return { value: item._id, label: item.teamName, type: item.entityType ? item.entityType : item.type };
      });
      this.filteredDeptOptions = [];
      this.departmentsList.map((item: any) => {
        let myItem:any = this.filteredDeptOptions.find((obj:any)=>{return obj.value == item._id});
        if(myItem == undefined){
          this.filteredDeptOptions.push({ value: item._id, label: item.teamName, type: item.entityType ? item.entityType : item.type  })
        }
      });
    },
    filterOpen() {
      if (this.columnObject == false) {
        this.showFilters = !this.showFilters;
        emitter.emit("visible", this.showFilters);
      }
    },
    
    colorLabelText(value: any) {
            if (value == 1) {
                return ["text-lightgreen font-semibold"];
            } else if (value == 2) {
                return ["text-green font-semibold"];
            } else if (value == 3) {
                return ["text-yellow font-semibold"];
            } else if (value == 4) {
                return ["text-error font-semibold"];
            } else if (value == 5) {
                return ["text-darkred font-semibold"];
            }
        },
        colorLabelBg(value: any) {
            if (value == 1) {
                return ["bg-veryLowColor border-solid border border-lightgreen"];
            } else if (value == 2) {
                return ["bg-lowColor border-solid border border-green"];
            } else if (value == 3) {
                return ["bg-moderateColor border-solid border border-yellow"];
            } else if (value == 4) {
                return ["bg-highColor border-solid border border-error"];
            } else if (value == 5) {
                return ["bg-veryHighColor border-solid border border-darkred"];
            }
        },
  },
});
</script>